(() => {
  'use strict';

  const root = document.getElementById('ganeshpos-quickorder');
  if (!root) return;

  // Keep the configured Ganesh POS palette available even if a theme or
  // Bootstrap moves a modal/overlay outside #ganeshpos-quickorder. The
  // values originate from the server-generated inline style on `root`.
  const corporateThemeVars = [
    '--gq-blue', '--gq-blue-2', '--gq-blue-text', '--gq-blue-soft',
    '--gq-blue-soft-2', '--gq-blue-border', '--gq-blue-border-strong',
    '--gq-blue-disabled', '--gq-blue-rgb', '--gq-on-blue', '--gq-app-bg',
  ];
  const rootThemeStyle = window.getComputedStyle(root);
  corporateThemeVars.forEach((name) => {
    const value = rootThemeStyle.getPropertyValue(name).trim();
    if (value) document.documentElement.style.setProperty(name, value);
  });

  document.body.classList.add('gq-immersive-body');
  function updateImmersiveLayout() {
    document.body.classList.add('gq-immersive-body');
    root.style.top = '0px';
    // Do not call closeMobileCart() here: this function runs before the mobile
    // element constants are initialized. Accessing them during initial desktop
    // load aborts the whole script and leaves the catalogue at "Cargando...".
    if (window.innerWidth > 980) {
      root.classList.remove('gq--cart-open');
      document.documentElement.classList.remove('gq-mobile-cart-open');
      const overlay = document.getElementById('gq-mobile-overlay');
      if (overlay) overlay.hidden = true;
    }
  }
  updateImmersiveLayout();
  window.addEventListener('resize', updateImmersiveLayout, { passive: true });

  // The standalone shell intentionally does not load the storefront theme JS.
  // Recreate the only core form enhancement needed by login/registration: the
  // password visibility control generated by PrestaShop forms.
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest ? event.target.closest('[data-action="show-password"]') : null;
    if (!toggle || !root.contains(toggle)) return;
    const group = toggle.closest('.input-group') || toggle.parentElement;
    const input = group ? group.querySelector('input[type="password"],input[data-gq-password-visible="1"]') : null;
    if (!input) return;
    const showing = input.type === 'text';
    input.type = showing ? 'password' : 'text';
    input.dataset.gqPasswordVisible = showing ? '0' : '1';
    toggle.setAttribute('aria-label', showing ? 'Mostrar contraseña' : 'Ocultar contraseña');
  });

  const $ = (id) => document.getElementById(id);
  const parseJson = (value, fallback) => {
    try {
      const parsed = JSON.parse(value || '');
      return parsed ?? fallback;
    } catch (_) {
      return fallback;
    }
  };
  const ajaxUrl = root.dataset.ajaxUrl;
  let token = root.dataset.token || '';
  const accountUrl = root.dataset.accountUrl || '#';
  const homeConfig = parseJson(root.dataset.homeConfig, { order: ['slider', 'catalog', 'foryou', 'recent', 'flash', 'favorites', 'orders', 'purchased', 'latest', 'bestsellers'], modes: {}, blocks: [], flash: {} });
  const homeOrder = Array.isArray(homeConfig.order) ? homeConfig.order.map(String) : [];
  const homeModes = homeConfig.modes && typeof homeConfig.modes === 'object' ? homeConfig.modes : {};
  const configurableBlocks = Array.isArray(homeConfig.blocks) ? homeConfig.blocks : [];
  const flashConfig = homeConfig.flash && typeof homeConfig.flash === 'object' ? homeConfig.flash : {};
  const initialCatalog = parseJson(root.dataset.initialCategories, { rootId: Number(root.dataset.rootCategoryId || 0), items: [] });
  const cacheEnabled = root.dataset.cacheEnabled === '1';
  const cacheNamespace = root.dataset.cacheNamespace || 'gq-0.17.16';
  const cacheTtls = {
    categories: Math.max(60, Number(root.dataset.cacheCategoriesTtl || 900)) * 1000,
    products: Math.max(30, Number(root.dataset.cacheProductsTtl || 120)) * 1000,
    blocks: Math.max(60, Number(root.dataset.cacheBlocksTtl || 300)) * 1000,
    search: Math.min(120, Math.max(30, Number(root.dataset.cacheProductsTtl || 120))) * 1000,
  };
  const prefetchNextEnabled = root.dataset.prefetchNext === '1';
  const pwaEnabled = root.dataset.pwaEnabled === '1';
  const pwaInstallMode = Number(root.dataset.pwaInstallMode || 0);
  const pwaManifestUrl = root.dataset.pwaManifestUrl || '';
  const pwaServiceWorkerUrl = root.dataset.pwaServiceWorkerUrl || '';
  const pwaScope = root.dataset.pwaScope || undefined;
  const pwaName = root.dataset.pwaName || 'Compra rápida';
  const pushEnabled = root.dataset.pushEnabled === '1';
  const pushPublicKey = root.dataset.pushPublicKey || '';
  const favoriteKeys = new Set(String(root.dataset.favoriteKeys || '').split(',').filter(Boolean));
  const lowStockThreshold = Math.max(1, Number(root.dataset.lowStockThreshold || 5));
  const responseCache = new Map();
  const accountModal = $('gq-account-modal');
  const accountFrame = $('gq-account-frame');
  const accountLoading = $('gq-account-loading');
  const currency = root.dataset.currency || 'EUR';
  const money = new Intl.NumberFormat(document.documentElement.lang || 'es-ES', { style: 'currency', currency });
  const browser = $('gq-browser');
  const searchInput = $('gq-search');
  const searchClear = $('gq-search-clear');
  const sentinel = $('gq-load-sentinel');
  const alertNode = $('gq-alert');
  const cartLines = $('gq-cart-lines');
  const cartCount = $('gq-cart-count');
  const productsTotal = $('gq-products-total');
  const discountsTotal = $('gq-discounts-total');
  const shippingTotal = $('gq-shipping-total');
  const totalNode = $('gq-total');
  const discountRow = $('gq-discount-row');
  const shippingRow = $('gq-shipping-row');
  const couponsNode = $('gq-coupons');
  const availableCouponsNode = $('gq-available-coupons');
  const freeShippingProgressNode = $('gq-free-shipping-progress');
  const couponInput = $('gq-coupon');
  const couponApply = $('gq-coupon-apply');
  const checkoutButton = $('gq-checkout');
  const customerAccess = $('gq-customer-access');
  const loginModal = $('gq-login-modal');
  const registerModal = $('gq-register-modal');
  const addressAccess = $('gq-address-access');
  const addressSelect = $('gq-address-select');
  const addressNew = $('gq-address-new');
  const addressEdit = $('gq-address-edit');
  const addressModal = $('gq-address-modal');
  const addressForm = $('gq-address-form');
  const addressId = $('gq-address-id');
  const addressAlias = $('gq-address-alias');
  const addressPhone = $('gq-address-phone');
  const addressLine1 = $('gq-address-line1');
  const addressLine2 = $('gq-address-line2');
  const addressPostcode = $('gq-address-postcode');
  const addressCity = $('gq-address-city');
  const addressCountry = $('gq-address-country');
  const addressState = $('gq-address-state');
  const addressStateWrap = $('gq-address-state-wrap');
  const carrierWrap = $('gq-carrier-wrap');
  const carrierSelect = $('gq-carrier-select');
  const carrierHelp = $('gq-carrier-help');
  const paymentWrap = $('gq-payment-wrap');
  const paymentSelect = $('gq-payment-select');
  const paymentHelp = $('gq-payment-help');
  const paymentModal = $('gq-payment-modal');
  const paymentContent = $('gq-payment-content');
  const quickViewModal = $('gq-quickview-modal');
  const quickViewContent = $('gq-quickview-content');
  const checkoutBaseUrl = root.dataset.checkoutUrl || checkoutButton?.getAttribute('href') || '#';
  const stepCustomer = $('gq-step-customer-value');
  const stepAddress = $('gq-step-address-value');
  const stepCarrier = $('gq-step-carrier-value');
  const stepPayment = $('gq-step-payment-value');
  const stepCoupon = $('gq-step-coupon-value');
  const searchButton = root.querySelector('.gq__search-button');
  const mobileCartOpen = $('gq-mobile-cart-open');
  const mobileCartClose = $('gq-mobile-cart-close');
  const mobileOverlay = $('gq-mobile-overlay');
  const mobileCount = $('gq-mobile-count');
  const mobileTotal = $('gq-mobile-total');
  const mobileCheckout = $('gq-mobile-checkout');
  const homeSections = $('gq-home-sections');
  const catalogPanel = $('gq-catalog-panel');
  const interactionRoot = homeSections || browser;
  const homeSlider = $('gq-home-slider');
  const homeSliderClose = $('gq-home-slider-close');
  const homeSliderDismissVersion = String(homeConfig.sliderDismissVersion || '1').replace(/[^a-zA-Z0-9._-]/g, '_');
  const homeSliderStorageKey = `ganeshpos_quickorder_slider_dismissed:${homeSliderDismissVersion}`;
  function initEmbeddedHomeSlider() {
    if (!homeSlider) return;
    const widget = homeSlider.querySelector('.gq__native-slider');
    if (!widget || widget.dataset.gqInitialized === '1') return;

    const slides = Array.from(widget.querySelectorAll('[data-gq-slide]'));
    if (!slides.length) return;
    widget.dataset.gqInitialized = '1';

    const dots = Array.from(widget.querySelectorAll('[data-gq-slider-dot]'));
    const prev = widget.querySelector('[data-gq-slider-prev]');
    const next = widget.querySelector('[data-gq-slider-next]');
    const interval = Math.max(1500, Number(widget.dataset.interval || 5000));
    const shouldWrap = widget.dataset.wrap !== 'false';
    const pauseOnHover = widget.dataset.pause === 'hover';
    let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let timer = null;

    function activate(index) {
      if (!slides.length) return;
      let target = Number(index);
      if (shouldWrap) {
        target = (target + slides.length) % slides.length;
      } else {
        target = Math.max(0, Math.min(slides.length - 1, target));
      }
      slides.forEach((slide, i) => {
        const active = i === target;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === target));
      current = target;
    }

    function stop() {
      if (timer !== null) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function advance() {
      if (!shouldWrap && current >= slides.length - 1) {
        stop();
        return;
      }
      activate(current + 1);
    }

    function start() {
      stop();
      if (slides.length < 2 || document.hidden) return;
      timer = window.setInterval(advance, interval);
    }

    prev?.addEventListener('click', () => {
      activate(current - 1);
      start();
    });
    next?.addEventListener('click', () => {
      activate(current + 1);
      start();
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        activate(Number(dot.dataset.gqSliderDot || 0));
        start();
      });
    });

    if (pauseOnHover) {
      widget.addEventListener('mouseenter', stop);
      widget.addEventListener('mouseleave', start);
      widget.addEventListener('focusin', stop);
      widget.addEventListener('focusout', start);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    activate(current);
    start();
  }

  initEmbeddedHomeSlider();

  const pwaInstallButton = $('gq-pwa-install');
  const pwaModalInstallButton = $('gq-pwa-modal-install');
  const pushToggleButton = $('gq-push-toggle');
  const pwaModal = $('gq-pwa-modal');
  let deferredInstallPrompt = null;
  let volatilePwaDeviceId = '';
  let defaultPushActivationArmed = false;
  let pwaProbeListenerReady = false;

  let categories = [];
  let rootCategoryId = 0;
  let currentCategoryId = 0;
  let categoryOffset = 0;
  let categoryTotal = 0;
  let categoryLoading = false;
  let categoryHasMore = false;
  let searchTimer = null;
  let searchController = null;
  let mode = 'categories';
  let selectedPaymentId = '';
  let cartHasLines = false;
  let paymentProcessing = false;
  let categoryPrefetch = null;

  const esc = (value) => String(value ?? '')
    .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;').replaceAll("'", '&#039;');

  function iconSvg(name, className = 'gq__svg-icon') {
    const icons = {
      category: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5.5h6l2 2H20v11H4z"/><path d="M4 9h16"/></svg>',
      user: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="3.5"/><path d="M5 20c.7-4 3.1-6 7-6s6.3 2 7 6"/></svg>',
      eye: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2.8 12s3.4-6 9.2-6 9.2 6 9.2 6-3.4 6-9.2 6-9.2-6-9.2-6Z"/><circle cx="12" cy="12" r="2.8"/></svg>',
      cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="19" r="1.6"/><circle cx="18" cy="19" r="1.6"/><path d="M3 5h2l2 9.5h10.6l1.8-7H6.2"/><path d="M8 9h8"/></svg>',
      heart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.8 5.8a5.1 5.1 0 0 0-7.2 0L12 7.4l-1.6-1.6a5.1 5.1 0 0 0-7.2 7.2L12 21l8.8-8a5.1 5.1 0 0 0 0-7.2Z"/></svg>',
      repeat: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M17 2l4 4-4 4"/><path d="M3 11V9a3 3 0 0 1 3-3h15"/><path d="M7 22l-4-4 4-4"/><path d="M21 13v2a3 3 0 0 1-3 3H3"/></svg>',
      history: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/><path d="M12 7v5l3.2 2"/></svg>',
      sparkles: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l1.2 3.4L16.5 8l-3.3 1.5L12 13l-1.2-3.5L7.5 8l3.3-1.6L12 3Z"/><path d="M18.5 13l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2Z"/><path d="M5.5 14l.7 1.8 1.8.7-1.8.7L5.5 19l-.7-1.8-1.8-.7 1.8-.7.7-1.8Z"/></svg>',
      flame: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.5 2.5c.6 3-1.1 4.2-2.6 5.8-1.7 1.8-2.9 3.4-2.3 5.8.4 1.5 1.5 2.4 2.7 2.8-.5-1.5.1-2.7 1-3.8 1.1 1 2.3 2.3 2.3 4.3 1.6-.8 2.9-2.5 3-4.8.2-3.7-2.1-6.7-4.1-10.1Z"/><path d="M6.8 11.2c-1.2 1.4-1.9 3-1.8 4.7.2 3.4 3.1 5.6 7 5.6 4 0 7-2.4 7-6.2"/></svg>',
      star: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.2l2.7 5.5 6.1.9-4.4 4.3 1 6.1-5.4-2.9L6.6 20l1-6.1-4.4-4.3 6.1-.9L12 3.2Z"/></svg>',
      chevron: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m7 9 5 5 5-5"/></svg>',
    };
    const svg = icons[name] || icons.category;
    return svg.replace('<svg ', `<svg class="${className}" `);
  }

  function openMobileCart() {
    if (window.innerWidth > 980) return;
    root.classList.add('gq--cart-open');
    document.documentElement.classList.add('gq-mobile-cart-open');
    if (mobileOverlay) mobileOverlay.hidden = false;
  }

  function closeMobileCart() {
    root.classList.remove('gq--cart-open');
    document.documentElement.classList.remove('gq-mobile-cart-open');
    if (mobileOverlay) mobileOverlay.hidden = true;
  }

  function notify(message, type = 'danger') {
    alertNode.innerHTML = `<div class="gq__notice gq__notice--${type}">${esc(message)}</div>`;
    window.setTimeout(() => {
      if (alertNode.textContent.includes(message)) alertNode.innerHTML = '';
    }, 6000);
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 980px)').matches;
  }

  function isDisplayModeVisible(displayMode) {
    const value = Number(displayMode || 0);
    if (value === 3) return true;
    if (value === 1) return !isMobileViewport();
    if (value === 2) return isMobileViewport();
    return false;
  }

  function requestCacheTtl(action) {
    if (!cacheEnabled) return 0;
    if (action === 'categories') return cacheTtls.categories;
    if (action === 'categoryProducts') return cacheTtls.products;
    if (action === 'showcaseProducts' || action === 'showcaseBatch') return cacheTtls.blocks;
    if (action === 'search') return cacheTtls.search;
    if (action === 'productQuickView') return cacheTtls.products;
    return 0;
  }

  function requestCacheKey(action, params) {
    const sorted = Object.keys(params || {}).sort().map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(String(params[key]))}`).join('&');
    return `${cacheNamespace}:${action}:${sorted}`;
  }

  function readResponseCache(key, allowExpired = false) {
    if (!cacheEnabled || !key) return null;
    const now = Date.now();
    const memory = responseCache.get(key);
    if (memory && (allowExpired || memory.expires > now)) return memory.value;
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      const stored = JSON.parse(raw);
      if (!stored || (!allowExpired && Number(stored.expires || 0) <= now)) {
        sessionStorage.removeItem(key);
        return null;
      }
      responseCache.set(key, stored);
      return stored.value ?? null;
    } catch (_) {
      return null;
    }
  }

  function writeResponseCache(key, value, ttl) {
    if (!cacheEnabled || !key || !ttl) return;
    const stored = { expires: Date.now() + ttl, value };
    responseCache.set(key, stored);
    try { sessionStorage.setItem(key, JSON.stringify(stored)); } catch (_) {}
  }

  function clearResponseCache() {
    responseCache.clear();
    try {
      const prefix = `${cacheNamespace}:`;
      Object.keys(sessionStorage).filter((key) => key.startsWith(prefix)).forEach((key) => sessionStorage.removeItem(key));
    } catch (_) {}
  }

  function warmImageUrls(urls) {
    const unique = Array.from(new Set((urls || []).filter(Boolean))).slice(0, 36);
    const schedule = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 80));
    schedule(() => unique.forEach((url) => {
      const image = new Image();
      image.decoding = 'async';
      image.src = String(url);
    }));
  }

  function warmProductImages(items, limit = 4) {
    // Only warm a handful of visible cover images. Warming every product and
    // every variant defeats native lazy-loading and can add several MB to the
    // initial PageSpeed network trace.
    warmImageUrls((items || []).slice(0, Math.max(0, limit)).map((item) => item?.imageUrl).filter(Boolean));
  }

  function prefetchCategoryPage(categoryId, offset, limit = 30) {
    if (!prefetchNextEnabled || !categoryId || offset < 0) return;
    const key = `${categoryId}:${offset}:${limit}`;
    if (categoryPrefetch?.key === key) return;
    const schedule = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 100));
    categoryPrefetch = { key, promise: null };
    schedule(() => {
      if (!categoryPrefetch || categoryPrefetch.key !== key) return;
      categoryPrefetch.promise = request('categoryProducts', { categoryId, offset, limit })
        .then((payload) => payload)
        .catch(() => null);
    });
  }

  async function request(action, params = {}, method = 'GET', options = {}) {
    if (method === 'GET') {
      const ttl = requestCacheTtl(action);
      const cacheKey = ttl ? requestCacheKey(action, params) : '';
      if (cacheKey && !options.force) {
        const cached = readResponseCache(cacheKey);
        if (cached) return cached;
      }

      const url = new URL(ajaxUrl, window.location.origin);
      url.searchParams.set('ajax', '1');
      url.searchParams.set('action', action);
      Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, String(value)));
      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
          signal: options.signal,
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || payload.ok === false) throw new Error(payload.error || `HTTP ${response.status}`);
        if (cacheKey) writeResponseCache(cacheKey, payload, ttl);
        return payload;
      } catch (error) {
        if (cacheKey && error?.name !== 'AbortError') {
          const stale = readResponseCache(cacheKey, true);
          if (stale) return stale;
        }
        throw error;
      }
    }

    const body = new URLSearchParams({ ajax: '1', action, token });
    Object.entries(params).forEach(([key, value]) => body.set(key, String(value)));
    const response = await fetch(ajaxUrl, {
      method: 'POST',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', Accept: 'application/json' },
      body,
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload.ok === false) throw new Error(payload.error || `HTTP ${response.status}`);
    return payload;
  }

  function stockBadge(stock) {
    const qty = Number(stock || 0);
    if (qty <= 0) return '<span class="gq__stock-badge gq__stock-badge--out">Agotado</span>';
    if (qty <= lowStockThreshold) return `<span class="gq__stock-badge gq__stock-badge--low">Últimas ${qty} uds.</span>`;
    return '<span class="gq__stock-badge gq__stock-badge--ok">En stock</span>';
  }

  function promotionMarkup(price, regularPrice, discountPercent, quantityTiers = []) {
    const current = Number(price || 0);
    const regular = Number(regularPrice || 0);
    const pct = Number(discountPercent || 0);
    const tier = Array.isArray(quantityTiers) && quantityTiers.length ? quantityTiers[0] : null;
    let html = '';
    if (regular > current + 0.001) {
      html += `<span class="gq__regular-price">${money.format(regular)}</span><span class="gq__discount-badge">-${Math.round(pct)}%</span>`;
    }
    if (tier && Number(tier.quantity) > 1 && Number(tier.price) > 0) {
      html += `<small class="gq__quantity-deal">Desde ${Number(tier.quantity)} uds.: ${money.format(Number(tier.price))}/ud.</small>`;
    }
    return html;
  }

  function productCard(item, priority = false) {
    const variants = Array.isArray(item.variants) ? item.variants : [];
    const selected = variants.find((v) => Number(v.id) === Number(item.attributeId || 0)) || variants[0] || null;
    const attrId = Number(selected?.id ?? item.attributeId ?? 0);
    const ref = selected?.reference || item.reference || selected?.ean13 || item.ean13 || `#${item.id}`;
    const price = Number(selected?.price ?? item.price ?? 0);
    const regularPrice = Number(selected?.regularPrice ?? item.regularPrice ?? price);
    const discountPercent = Number(selected?.discountPercent ?? item.discountPercent ?? 0);
    const quantityTiers = Array.isArray(selected?.quantityTiers) ? selected.quantityTiers : (Array.isArray(item.quantityTiers) ? item.quantityTiers : []);
    const stock = Number(selected?.stock ?? item.stock ?? 0);
    const key = `${Number(item.id)}:${attrId}`;
    const imageUrl = selected?.imageUrl || item.imageUrl || '';
    const personalizationReason = String(item.personalizationReason || '').trim();
    const image = imageUrl ? `<img class="gq__product-img" src="${esc(imageUrl)}" alt="${esc(item.name)}" loading="${priority ? 'eager' : 'lazy'}" decoding="async" fetchpriority="${priority ? 'high' : 'low'}">` : '<span class="gq__product-placeholder">Sin imagen</span>';
    const variantSelect = variants.length > 1 ? `<select class="gq__variant-select" data-variant-product="${Number(item.id)}" aria-label="Elegir variante">${variants.map((v) => `<option value="${Number(v.id)}" data-price="${Number(v.price)}" data-regular-price="${Number(v.regularPrice ?? v.price)}" data-discount="${Number(v.discountPercent || 0)}" data-tiers="${esc(JSON.stringify(v.quantityTiers || []))}" data-stock="${Number(v.stock)}" data-ref="${esc(v.reference || v.ean13 || '')}" data-image="${esc(v.imageUrl || '')}" ${Number(v.id)===attrId?'selected':''}>${esc(v.name || v.reference || ('Variante '+v.id))}</option>`).join('')}</select>` : '';
    return `<article class="gq__product" data-product-card="${Number(item.id)}" ${stock <= 0 ? 'data-out="1"' : ''}>
      <button type="button" class="gq__favorite ${favoriteKeys.has(key)?'is-active':''}" data-favorite-product="${Number(item.id)}" data-favorite-attribute="${attrId}" aria-label="Añadir a Mis habituales">♥</button>
      <button type="button" class="gq__product-main" data-add-product="${Number(item.id)}" data-add-attribute="${attrId}" ${stock <= 0 ? 'disabled' : ''}>
        <span class="gq__product-media">${image}<span data-stock-badge>${stockBadge(stock)}</span></span>
        <span class="gq__product-body"><strong>${esc(item.name)}</strong>${personalizationReason ? `<small class="gq__personalization-reason">${esc(personalizationReason)}</small>` : ''}<small data-product-meta>SKU: ${esc(ref)} · Stock: ${stock}</small></span>
      </button>
      ${variantSelect}
      <div class="gq__promo-row" data-product-promo>${promotionMarkup(price, regularPrice, discountPercent, quantityTiers)}</div>
      <span class="gq__product-price-row"><strong class="gq__product-price" data-product-price>${money.format(price)}</strong><span class="gq__product-actions"><button type="button" class="gq__view-label gq__icon-button" data-view-product="${Number(item.id)}" data-view-attribute="${attrId}" aria-label="Ver producto" title="Ver producto">${iconSvg('eye')}</button><input class="gq__card-qty" data-card-qty type="number" min="1" max="${Math.max(1,stock)}" value="1" aria-label="Cantidad"><button type="button" class="gq__add-label gq__icon-button" data-add-product="${Number(item.id)}" data-add-attribute="${attrId}" aria-label="Añadir al carrito" title="Añadir al carrito" ${stock<=0?'disabled':''}>${iconSvg('cart')}</button></span></span>
    </article>`;
  }

  function categoryCard(item) {
    const details = [];
    if (Number(item.childCount) > 0) details.push(`${Number(item.childCount)} subcategorías`);
    if (Number(item.productCount) > 0) details.push(`${Number(item.productCount)} productos`);
    const visual = item.imageUrl
      ? `<span class="gq__category-icon gq__category-icon--image"><img src="${esc(item.imageUrl)}" alt="${esc(item.name)}" loading="lazy" decoding="async" fetchpriority="low"></span>`
      : `<span class="gq__category-icon gq__category-icon--generic">${iconSvg('category')}</span>`;
    return `<button type="button" class="gq__category" data-category="${Number(item.id)}">${visual}<strong>${esc(item.name)}</strong><small>${esc(details.join(' · ') || 'Abrir categoría')}</small></button>`;
  }

  function childrenOf(parentId) {
    return categories.filter((item) => Number(item.parentId) === Number(parentId));
  }

  function categoryById(id) {
    return categories.find((item) => Number(item.id) === Number(id)) || null;
  }

  function isHomeSliderDismissed() {
    try {
      return window.localStorage.getItem(homeSliderStorageKey) === '1';
    } catch (_) {
      return false;
    }
  }

  function dismissHomeSlider() {
    try {
      window.localStorage.setItem(homeSliderStorageKey, '1');
    } catch (_) {}
    if (homeSlider) homeSlider.hidden = true;
    root.classList.remove('gq--home-slider-visible');
  }

  function isStandalonePwa() {
    return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
  }

  function updatePwaInstallButton() {
    const visible = pwaEnabled && isDisplayModeVisible(pwaInstallMode) && !isStandalonePwa();
    if (pwaInstallButton) pwaInstallButton.hidden = !visible;
    if (pwaModalInstallButton) {
      // Keep the main CTA visible in the helper even before Chromium emits
      // beforeinstallprompt. installPwa() will use the native prompt, the Web
      // Install API when available, or reveal the manual fallback instructions.
      pwaModalInstallButton.hidden = !visible;
      pwaModalInstallButton.disabled = false;
    }
  }

  function openPwaHelp() {
    if (!pwaModal) return;
    pwaModal.hidden = false;
    document.documentElement.classList.add('gq-modal-open');
  }

  function closePwaHelp() {
    if (!pwaModal) return;
    pwaModal.hidden = true;
    document.documentElement.classList.remove('gq-modal-open');
  }

  async function installPwa() {
    if (deferredInstallPrompt) {
      closePwaHelp();
      deferredInstallPrompt.prompt();
      try { await deferredInstallPrompt.userChoice; } catch (_) {}
      deferredInstallPrompt = null;
      updatePwaInstallButton();
      return;
    }

    // Chromium versions exposing the Web Install API can still launch a native
    // install flow even when beforeinstallprompt was not delivered to this page.
    if (typeof navigator.install === 'function') {
      try {
        const installUrl = new URL(window.location.href);
        installUrl.searchParams.delete('gq_install');
        await navigator.install(installUrl.toString());
        return;
      } catch (_) {}
    }

    openPwaHelp();
    const browserHelp = $('gq-pwa-browser-help');
    if (browserHelp) browserHelp.hidden = false;
  }

  function readPwaCookie(name) {
    try {
      const prefix = `${encodeURIComponent(name)}=`;
      const found = String(document.cookie || '').split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
      return found ? decodeURIComponent(found.slice(prefix.length)) : '';
    } catch (_) { return ''; }
  }

  function writePwaCookie(name, value, maxAge = 63072000) {
    try {
      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Max-Age=${Math.max(0, Number(maxAge) || 0)}; Path=/; SameSite=Lax; Secure`;
    } catch (_) {}
  }

  function pwaDeviceId() {
    const key = 'ganeshpos_pwa_device_id';
    try {
      let value = window.localStorage.getItem(key) || readPwaCookie(key) || '';
      if (!value) {
        value = (window.crypto && typeof window.crypto.randomUUID === 'function')
          ? window.crypto.randomUUID()
          : `gq-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
      }
      window.localStorage.setItem(key, value);
      writePwaCookie(key, value);
      return value;
    } catch (_) {
      let value = readPwaCookie(key);
      if (!value) value = volatilePwaDeviceId || `gq-${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
      volatilePwaDeviceId = value;
      writePwaCookie(key, value);
      return value;
    }
  }

  function pwaPlatform() {
    return String(navigator.userAgentData?.platform || navigator.platform || '').slice(0, 80);
  }

  function pushPermission() {
    return typeof Notification === 'undefined' ? 'unsupported' : String(Notification.permission || 'default');
  }

  function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
    const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
    const rawData = window.atob(base64);
    return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
  }

  function pushSubscriptionUsesCurrentKey(subscription) {
    if (!subscription || !pushPublicKey) return false;
    const actualBuffer = subscription.options?.applicationServerKey;
    if (!actualBuffer) return true;
    try {
      const expected = urlBase64ToUint8Array(pushPublicKey);
      const actual = new Uint8Array(actualBuffer);
      if (actual.length !== expected.length) return false;
      for (let i = 0; i < actual.length; i += 1) {
        if (actual[i] !== expected[i]) return false;
      }
      return true;
    } catch (_) {
      return true;
    }
  }

  function rememberPwaInstalled(value = true) {
    const key = 'ganeshpos_pwa_was_installed';
    try {
      if (value) window.localStorage.setItem(key, '1');
      else window.localStorage.removeItem(key);
    } catch (_) {}
    writePwaCookie(key, value ? '1' : '', value ? 63072000 : 0);
  }

  function wasPwaInstalledHere() {
    const key = 'ganeshpos_pwa_was_installed';
    try { return window.localStorage.getItem(key) === '1' || readPwaCookie(key) === '1'; }
    catch (_) { return readPwaCookie(key) === '1'; }
  }

  async function detectPwaInstallationState() {
    if (isStandalonePwa()) {
      rememberPwaInstalled(true);
      return 'installed';
    }
    // Chromium can verify a same-origin related PWA from the normal browser page.
    // This gives us an explicit uninstall signal after a previously installed app
    // disappears, instead of treating a historic registration as permanent.
    if (typeof navigator.getInstalledRelatedApps === 'function') {
      try {
        const related = await navigator.getInstalledRelatedApps();
        const installed = Array.isArray(related) && related.some((app) => String(app?.platform || '') === 'webapp');
        if (installed) {
          rememberPwaInstalled(true);
          return 'installed';
        }
        if (wasPwaInstalledHere()) {
          rememberPwaInstalled(false);
          return 'uninstalled';
        }
      } catch (_) {}
    }
    return 'unknown';
  }

  async function sendPwaHeartbeat(stateOverride = null) {
    if (!pushEnabled) return;
    const installationState = stateOverride || await detectPwaInstallationState();
    try {
      await request('pwaHeartbeat', {
        deviceId: pwaDeviceId(),
        installationState,
        permission: pushPermission(),
        platform: pwaPlatform(),
      }, 'POST');
    } catch (_) {}
  }

  async function currentPushSubscription() {
    if (!pushEnabled || !('serviceWorker' in navigator) || !('PushManager' in window)) return null;
    try {
      const registration = await navigator.serviceWorker.ready;
      return await registration.pushManager.getSubscription();
    } catch (_) {
      return null;
    }
  }

  async function updatePushToggle() {
    if (!pushToggleButton) return;
    const supported = pushEnabled && pushPublicKey && isStandalonePwa()
      && 'serviceWorker' in navigator && 'PushManager' in window && typeof Notification !== 'undefined';
    pushToggleButton.hidden = !supported;
    if (!supported) return;

    const permission = pushPermission();
    const subscription = permission === 'granted' ? await currentPushSubscription() : null;
    pushToggleButton.classList.toggle('is-active', Boolean(subscription));
    pushToggleButton.classList.toggle('is-blocked', permission === 'denied');
    pushToggleButton.disabled = permission === 'denied';
    const label = pushToggleButton.querySelector('span');
    if (permission === 'denied') {
      if (label) label.textContent = 'Avisos bloqueados';
      pushToggleButton.title = 'Activa las notificaciones desde los permisos del navegador';
    } else if (subscription) {
      if (label) label.textContent = 'Avisos activos';
      pushToggleButton.title = 'Notificaciones activadas. Pulsa para desactivarlas.';
    } else {
      if (label) label.textContent = 'Activar avisos';
      pushToggleButton.title = 'Recibir notificaciones de la tienda';
    }
  }

  async function enablePushNotifications(options = {}) {
    const auto = Boolean(options.auto);
    if (!pushEnabled || !pushPublicKey || !isStandalonePwa()) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || typeof Notification === 'undefined') {
      if (!auto) notify('Este dispositivo no admite notificaciones Push.', 'danger');
      return;
    }

    // Request the browser permission before awaiting any other promise. Several
    // browsers only accept this request while the user gesture is still active.
    let permission = pushPermission();
    if (permission === 'default') {
      try { permission = await Notification.requestPermission(); } catch (_) { permission = pushPermission(); }
    }
    await sendPwaHeartbeat();
    if (permission !== 'granted') {
      if (!auto) {
        notify(permission === 'denied' ? 'Las notificaciones están bloqueadas en el navegador.' : 'No se han activado las notificaciones.', 'danger');
      }
      await updatePushToggle();
      return;
    }

    let existing = await currentPushSubscription();
    if (existing && !pushSubscriptionUsesCurrentKey(existing)) {
      try { await existing.unsubscribe(); } catch (_) {}
      try {
        await request('pushUnsubscribe', { deviceId: pwaDeviceId(), permission: pushPermission() }, 'POST');
      } catch (_) {}
      existing = null;
    }

    if (existing && !auto) {
      if (window.confirm('¿Quieres desactivar las notificaciones de Compra rápida en este dispositivo?')) {
        try { await existing.unsubscribe(); } catch (_) {}
        try {
          await request('pushUnsubscribe', { deviceId: pwaDeviceId(), permission: pushPermission() }, 'POST');
        } catch (_) {}
        notify('Notificaciones desactivadas.', 'success');
        await updatePushToggle();
      }
      return;
    }

    try {
      const registration = await navigator.serviceWorker.ready;
      let subscription = existing || await registration.pushManager.getSubscription();
      if (!subscription) {
        subscription = await registration.pushManager.subscribe({
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(pushPublicKey),
        });
      }
      const json = subscription.toJSON();
      json.contentEncoding = (PushManager.supportedContentEncodings || ['aes128gcm'])[0] || 'aes128gcm';
      await request('pushSubscribe', {
        deviceId: pwaDeviceId(),
        installed: 1,
        platform: pwaPlatform(),
        subscription: JSON.stringify(json),
      }, 'POST');
      if (!auto) notify('Notificaciones activadas en este dispositivo.', 'success');
    } catch (error) {
      if (!auto) notify(error?.message || 'No se han podido activar las notificaciones.', 'danger');
    }
    await updatePushToggle();
  }

  function setupDefaultPushActivation() {
    if (!pushEnabled || !pushPublicKey || !isStandalonePwa()) return;
    if (defaultPushActivationArmed) return;
    if (!('serviceWorker' in navigator) || !('PushManager' in window) || typeof Notification === 'undefined') return;

    const permission = pushPermission();
    if (permission === 'denied') {
      updatePushToggle();
      return;
    }

    // If permission already exists, restore/create the Push subscription
    // automatically when the installed PWA opens.
    if (permission === 'granted') {
      defaultPushActivationArmed = true;
      enablePushNotifications({ auto: true }).finally(() => { defaultPushActivationArmed = false; });
      return;
    }

    // Browsers require the permission prompt to originate from a real user
    // gesture. On a newly installed PWA we use the first normal interaction,
    // so notifications are the default onboarding path without an extra button.
    const storageKey = 'ganeshpos_push_default_prompt_v1';
    try {
      if (window.localStorage.getItem(storageKey) === '1') return;
    } catch (_) {}

    defaultPushActivationArmed = true;
    let armed = true;
    const cleanup = () => {
      document.removeEventListener('pointerup', onFirstGesture, true);
      document.removeEventListener('touchend', onFirstGesture, true);
      document.removeEventListener('keydown', onFirstGesture, true);
      defaultPushActivationArmed = false;
    };
    const onFirstGesture = (event) => {
      if (!armed) return;
      if (event?.target?.closest?.('#gq-push-toggle')) return;
      armed = false;
      cleanup();
      try { window.localStorage.setItem(storageKey, '1'); } catch (_) {}
      enablePushNotifications({ auto: true });
    };
    document.addEventListener('pointerup', onFirstGesture, true);
    document.addEventListener('touchend', onFirstGesture, true);
    document.addEventListener('keydown', onFirstGesture, true);
  }

  function setupPwaProbeListener() {
    if (pwaProbeListenerReady || !('serviceWorker' in navigator)) return;
    pwaProbeListenerReady = true;
    navigator.serviceWorker.addEventListener('message', async (event) => {
      const data = event?.data || {};
      if (data.type !== 'ganeshpos-status-probe') return;
      const ackUrl = String(data.ackUrl || '');
      const deviceId = String(data.deviceId || '');
      const probeToken = String(data.probeToken || '');
      if (!ackUrl || !deviceId || !probeToken) return;
      let state = 'reachable';
      try { state = await detectPwaInstallationState(); } catch (_) {}
      if (!['installed', 'uninstalled'].includes(state)) state = 'reachable';
      try {
        const body = new URLSearchParams({ deviceId, probeToken, state });
        await fetch(ackUrl, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: body.toString(),
          cache: 'no-store',
          keepalive: true,
        });
      } catch (_) {}
      if (state === 'installed' || state === 'uninstalled') {
        try { await sendPwaHeartbeat(state); } catch (_) {}
      }
    });
  }

  function requestedPwaInstall() {
    try {
      return new URL(window.location.href).searchParams.get('gq_install') === '1';
    } catch (_) {
      return false;
    }
  }

  function setupPwa() {
    if (!pwaEnabled) return;
    setupPwaProbeListener();
    if (pwaManifestUrl && !document.querySelector('link[rel="manifest"]')) {
      const link = document.createElement('link');
      link.rel = 'manifest';
      link.href = pwaManifestUrl;
      document.head.appendChild(link);
    }
    if (pwaInstallButton) {
      pwaInstallButton.title = `Instalar ${pwaName}`;
      pwaInstallButton.setAttribute('aria-label', `Instalar ${pwaName}`);
    }
    if ('serviceWorker' in navigator && pwaServiceWorkerUrl) {
      const registerServiceWorker = () => {
        const options = { updateViaCache: 'none' };
        if (pwaScope) options.scope = pwaScope;
        return navigator.serviceWorker
          .register(pwaServiceWorkerUrl, options)
          .then(async (registration) => {
            // Force a network revalidation of the dynamic worker. This is
            // important for background-push fixes because an installed PWA
            // may otherwise keep an old worker for a long time.
            try { await registration.update(); } catch (_) {}
            updatePushToggle();
            setupDefaultPushActivation();
          })
          .catch((error) => console.warn('[Ganesh POS] No se pudo registrar la PWA:', error));
      };
      if (document.readyState === 'complete') registerServiceWorker();
      else window.addEventListener('load', registerServiceWorker, { once: true });

      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (pushPermission() === 'granted') {
          enablePushNotifications({ auto: true });
        }
      });
    }
    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      deferredInstallPrompt = event;
      // If this browser previously confirmed the PWA but now offers installation
      // again, it is a strong fallback signal that this installation was removed.
      if (!isStandalonePwa() && wasPwaInstalledHere()) {
        rememberPwaInstalled(false);
        sendPwaHeartbeat('uninstalled');
      }
      updatePwaInstallButton();
    });
    window.addEventListener('appinstalled', () => {
      deferredInstallPrompt = null;
      updatePwaInstallButton();
      rememberPwaInstalled(true);
      sendPwaHeartbeat('installed');
      try { window.localStorage.removeItem('ganeshpos_push_default_prompt_v1'); } catch (_) {}
      notify('Compra rápida se ha instalado correctamente. Los avisos se activarán al abrir la app.', 'success');
    });
    pwaInstallButton?.addEventListener('click', installPwa);
    pwaModalInstallButton?.addEventListener('click', installPwa);
    pushToggleButton?.addEventListener('click', enablePushNotifications);
    pwaModal?.addEventListener('click', (event) => {
      if (event.target === pwaModal || event.target.closest('[data-pwa-close]')) closePwaHelp();
    });
    updatePwaInstallButton();
    if (requestedPwaInstall() && !isStandalonePwa()) {
      // The storefront CTA requested installation. The native install event may
      // arrive just after load; when it does, the helper exposes a real install
      // button that triggers the browser prompt.
      window.setTimeout(() => {
        updatePwaInstallButton();
        openPwaHelp();
      }, 250);
    }
    sendPwaHeartbeat();
    updatePushToggle();
    setupDefaultPushActivation();
    window.setInterval(() => {
      if (!document.hidden && isStandalonePwa()) sendPwaHeartbeat('installed');
    }, 120000);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && isStandalonePwa()) {
        sendPwaHeartbeat('installed');
        updatePushToggle();
      }
    });
  }

  function homeSectionMode(key) {
    if (key.startsWith('block:')) {
      const blockId = key.slice(6);
      const block = configurableBlocks.find((item) => String(item.id || '') === blockId);
      return Number(block?.mode ?? 0);
    }
    return Number(homeModes[key] ?? (key === 'catalog' ? 3 : 0));
  }

  function homeSectionVisible(key) {
    return key === 'catalog' || isDisplayModeVisible(homeSectionMode(key));
  }

  function setHomeSliderVisible(visible) {
    if (!homeSlider) return;
    const show = Boolean(visible)
      && mode === 'categories'
      && isDisplayModeVisible(homeSectionMode('slider'))
      && !isHomeSliderDismissed();
    homeSlider.hidden = !show;
    root.classList.toggle('gq--home-slider-visible', show);
  }

  function showcasePresentation(type) {
    const normalized = String(type || '');
    if (normalized === 'foryou') return { icon: 'star', tone: 'foryou', hint: 'Elegido según tus intereses' };
    if (normalized === 'recent') return { icon: 'history', tone: 'recent', hint: 'Vuelve a lo que estabas mirando' };
    if (normalized === 'flash') return { icon: 'flame', tone: 'flash', hint: 'Oferta por tiempo limitado' };
    if (normalized === 'favorites') return { icon: 'heart', tone: 'favorites', hint: 'Favoritos y productos que sueles reponer' };
    if (normalized === 'orders') return { icon: 'repeat', tone: 'orders', hint: 'Compra de nuevo' };
    if (normalized === 'purchased') return { icon: 'history', tone: 'purchased', hint: 'Tu historial' };
    if (normalized === 'latest') return { icon: 'sparkles', tone: 'latest', hint: 'Recién añadidos' };
    if (normalized === 'bestsellers') return { icon: 'flame', tone: 'bestsellers', hint: 'Top ventas' };
    return { icon: 'star', tone: 'custom', hint: 'Selección especial' };
  }

  function showcaseAccordion(type, title, key = type) {
    const presentation = showcasePresentation(type);
    const hint = type === 'flash' && flashConfig.endsAt
      ? `<small class="gq__flash-countdown" data-flash-countdown="${esc(flashConfig.endsAt)}">Calculando tiempo…</small>`
      : `<small>${esc(presentation.hint)}</small>`;
    return `<section class="gq__showcase gq__showcase--${presentation.tone}" data-home-generated="1" data-home-section="${esc(key)}" data-showcase="${esc(type)}">
      <button type="button" class="gq__showcase-toggle" data-showcase-toggle="${esc(type)}" aria-expanded="false" aria-label="Abrir ${esc(title)}">
        <span class="gq__showcase-main"><span class="gq__showcase-icon gq__showcase-icon--${presentation.tone}">${iconSvg(presentation.icon, 'gq__showcase-svg')}</span><span class="gq__showcase-copy"><strong>${type === 'flash' && flashConfig.badge ? `<span class="gq__flash-badge">${esc(flashConfig.badge)}</span> ` : ''}${esc(title)}</strong>${hint}</span></span>
        <span class="gq__showcase-action"><span class="gq__showcase-action-label">Ver</span><span class="gq__showcase-chevron">${iconSvg('chevron', 'gq__showcase-chevron-svg')}</span></span>
      </button>
      <div class="gq__showcase-body" data-showcase-body="${esc(type)}" hidden></div>
    </section>`;
  }

  function customerIsLogged() {
    return Boolean(addressAccess && !addressAccess.hidden);
  }

  function homeSectionMarkup(key) {
    if (key === 'foryou' && isDisplayModeVisible(homeSectionMode(key))) {
      return showcaseAccordion('foryou', 'Para ti', key);
    }
    if (key === 'recent' && isDisplayModeVisible(homeSectionMode(key))) {
      return showcaseAccordion('recent', 'Vistos recientemente', key);
    }
    if (key === 'flash' && Boolean(flashConfig.active) && isDisplayModeVisible(homeSectionMode(key))) {
      return showcaseAccordion('flash', flashConfig.title || 'Oferta flash', key);
    }
    if (key === 'favorites') {
      return customerIsLogged() && isDisplayModeVisible(homeSectionMode(key))
        ? showcaseAccordion('favorites', 'Mis habituales', key)
        : '';
    }
    if (key === 'orders') {
      return customerIsLogged() && isDisplayModeVisible(homeSectionMode(key))
        ? showcaseAccordion('orders', 'Repetir pedido', key)
        : '';
    }
    if (key === 'purchased') {
      return customerIsLogged() && isDisplayModeVisible(homeSectionMode(key))
        ? showcaseAccordion('purchased', 'Comprados anteriormente', key)
        : '';
    }
    if (key === 'latest' && isDisplayModeVisible(homeSectionMode(key))) {
      return showcaseAccordion('latest', 'Últimas novedades', key);
    }
    if (key === 'bestsellers' && isDisplayModeVisible(homeSectionMode(key))) {
      return showcaseAccordion('bestsellers', 'Los más vendidos', key);
    }
    if (key.startsWith('block:') && isDisplayModeVisible(homeSectionMode(key))) {
      const blockId = key.slice(6);
      const block = configurableBlocks.find((item) => String(item.id || '') === blockId);
      if (block) return showcaseAccordion(`block:${blockId}`, block.title || 'Selección recomendada', key);
    }
    return '';
  }

  function updateFlashCountdowns() {
    document.querySelectorAll('[data-flash-countdown]').forEach((node) => {
      const end = Date.parse(node.dataset.flashCountdown || '');
      if (!Number.isFinite(end)) return;
      const remaining = Math.max(0, end - Date.now());
      if (remaining <= 0) {
        node.textContent = 'Oferta finalizada';
        return;
      }
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      node.textContent = `${days > 0 ? `${days}d ` : ''}${String(hours).padStart(2,'0')}:${String(minutes).padStart(2,'0')}:${String(seconds).padStart(2,'0')}`;
    });
  }
  window.setInterval(updateFlashCountdowns, 1000);

  function enterBrowseMode() {
    root.classList.remove('gq--home-mode');
    if (homeSections) {
      homeSections.querySelectorAll('[data-home-generated="1"]').forEach((node) => node.remove());
      if (catalogPanel) homeSections.append(catalogPanel);
    }
    setHomeSliderVisible(false);
  }

  function renderHomeSections() {
    if (!homeSections || !catalogPanel) return;
    root.classList.add('gq--home-mode');
    homeSections.querySelectorAll('[data-home-generated="1"]').forEach((node) => node.remove());

    const order = homeOrder.length
      ? homeOrder
      : ['slider', 'catalog', 'foryou', 'recent', 'flash', 'favorites', 'orders', 'latest', 'bestsellers'];
    const fragment = document.createDocumentFragment();
    const used = new Set();

    order.forEach((key) => {
      if (used.has(key)) return;
      used.add(key);
      if (key === 'slider') {
        if (homeSlider) fragment.append(homeSlider);
        return;
      }
      if (key === 'catalog') {
        fragment.append(catalogPanel);
        return;
      }
      const markup = homeSectionMarkup(key);
      if (!markup) return;
      const holder = document.createElement('div');
      holder.innerHTML = markup.trim();
      if (holder.firstElementChild) fragment.append(holder.firstElementChild);
    });

    if (!used.has('catalog')) fragment.append(catalogPanel);
    homeSections.replaceChildren(fragment);
    updateFlashCountdowns();
    setHomeSliderVisible(true);
  }

  function renderRootCategories() {
    mode = 'categories';
    currentCategoryId = 0;
    categoryHasMore = false;
    categoryPrefetch = null;
    const items = childrenOf(rootCategoryId);
    browser.innerHTML = `
      <div class="gq__toolbar"><span class="gq__toolbar-title gq__toolbar-title--icon">${iconSvg('category')} Categorías</span></div>
      <div class="gq__category-grid">${items.length ? items.map(categoryCard).join('') : '<p class="gq__muted">No hay categorías disponibles.</p>'}</div>`;
    renderHomeSections();
    warmImageUrls(items.map((item) => item.imageUrl).filter(Boolean).slice(0, 12));
    scheduleShowcasePrefetch();
  }

  function selectorEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(String(value));
    return String(value).replace(/([\"'\[\]#.:;,>+~*^$|=()])/g, '\\$1');
  }

  async function toggleShowcase(type) {
    const scope = homeSections || browser;
    const section = scope.querySelector(`[data-showcase="${selectorEscape(type)}"]`);
    const button = section?.querySelector('[data-showcase-toggle]');
    const body = section?.querySelector('[data-showcase-body]');
    if (!section || !button || !body) return;
    const isOpen = button.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      button.setAttribute('aria-expanded', 'false');
      body.hidden = true;
      section.classList.remove('is-open');
      const anotherOpen = Boolean(scope.querySelector('.gq__showcase.is-open'));
      if (!anotherOpen && mode === 'categories' && searchInput.value.trim() === '') setHomeSliderVisible(true);
      return;
    }

    setHomeSliderVisible(false);
    button.setAttribute('aria-expanded', 'true');
    body.hidden = false;
    section.classList.add('is-open');
    if (body.dataset.loaded === '1') return;
    body.innerHTML = '<div class="gq__loading">Cargando productos…</div>';
    try {
      if (type === 'orders') {
        const payload = await request('orderHistory');
        const orders = Array.isArray(payload.items) ? payload.items : [];
        body.innerHTML = orders.length
          ? `<div class="gq__orders">${orders.map((o) => `<div class="gq__order-row"><span><strong>${esc(o.reference)}</strong><small>${esc(o.date)}</small></span><strong>${money.format(Number(o.total))}</strong><button type="button" class="btn btn-primary btn-sm" data-repeat-order="${Number(o.id)}">Repetir</button></div>`).join('')}</div>`
          : '<p class="gq__muted">Todavía no hay pedidos para repetir.</p>';
      } else {
        const showcaseParams = (type === 'foryou' || type === 'recent' || type === 'favorites') ? { type, deviceId: pwaDeviceId() } : { type };
        const payload = await request('showcaseProducts', showcaseParams);
        const products = Array.isArray(payload.items) ? payload.items : [];
        body.innerHTML = products.length
          ? `<div class="gq__product-grid gq__product-grid--showcase">${products.map((item, index) => productCard(item, false)).join('')}</div>`
          : '<p class="gq__muted gq__showcase-empty">No hay productos en este bloque.</p>';
        warmProductImages(products);
      }
      body.dataset.loaded = '1';
    } catch (error) {
      body.innerHTML = '<p class="gq__muted gq__showcase-empty">No se pudieron cargar los productos.</p>';
      notify(error.message);
    }
  }

  let showcasePrefetchScheduled = false;
  function scheduleShowcasePrefetch() {
    if (!prefetchNextEnabled || showcasePrefetchScheduled) return;
    showcasePrefetchScheduled = true;

    const run = () => {
      const schedule = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 600));
      schedule(async () => {
        if (mode !== 'categories' || searchInput.value.trim() !== '') return;
        const ordered = homeOrder.length ? homeOrder : ['latest', 'bestsellers'];
        const types = [];
        ordered.forEach((key) => {
          if (!homeSectionVisible(key)) return;
          if (key === 'latest' || key === 'bestsellers' || key === 'flash' || key.startsWith('block:')) types.push(key);
        });
        const uniqueTypes = Array.from(new Set(types)).slice(0, 4);
        if (!uniqueTypes.length) return;
        try {
          const payload = await request('showcaseBatch', { types: JSON.stringify(uniqueTypes) });
          const blocks = payload?.blocks && typeof payload.blocks === 'object' ? payload.blocks : {};
          Object.entries(blocks).forEach(([type, blockPayload]) => {
            const normalized = {
              ok: true,
              title: String(blockPayload?.title || ''),
              items: Array.isArray(blockPayload?.items) ? blockPayload.items : [],
            };
            writeResponseCache(requestCacheKey('showcaseProducts', { type }), normalized, cacheTtls.blocks);
          });
        } catch (_) {
          // Prefetching is opportunistic.
        }
      });
    };

    // Do not consume bandwidth during the initial Lighthouse/LCP window. Only
    // prefetch after the visitor has interacted with Compra rápida.
    const arm = () => {
      window.removeEventListener('pointerdown', arm);
      window.removeEventListener('keydown', arm);
      run();
    };
    window.addEventListener('pointerdown', arm, { passive: true, once: true });
    window.addEventListener('keydown', arm, { once: true });
  }

  function preloadProductImages(items) {
    (Array.isArray(items) ? items : []).slice(0, 30).forEach((item) => {
      if (!item?.imageUrl) return;
      const image = new Image();
      image.decoding = 'async';
      image.src = item.imageUrl;
    });
  }

  async function loadMoreCategoryProducts() {
    if (mode !== 'category' || !currentCategoryId || categoryLoading || (categoryOffset > 0 && !categoryHasMore)) return;
    categoryLoading = true;
    const progress = $('gq-category-progress');
    if (progress) progress.textContent = 'Cargando productos…';
    const requestedCategory = currentCategoryId;
    const requestedOffset = categoryOffset;
    const limit = 30;
    try {
      const prefetchKey = `${requestedCategory}:${requestedOffset}:${limit}`;
      let payload = null;
      if (categoryPrefetch?.key === prefetchKey && categoryPrefetch.promise) {
        payload = await categoryPrefetch.promise;
      }
      if (!payload) {
        payload = await request('categoryProducts', { categoryId: requestedCategory, offset: requestedOffset, limit });
      }
      if (mode !== 'category' || currentCategoryId !== requestedCategory) return;
      const grid = $('gq-category-products');
      if (!grid) return;
      const items = Array.isArray(payload.items) ? payload.items : [];
      grid.insertAdjacentHTML('beforeend', items.map((item, index) => productCard(item, index < 2)).join(''));
      categoryTotal = Number(payload.total || 0);
      categoryOffset = requestedOffset + Number(payload.limit || limit);
      categoryHasMore = categoryOffset < categoryTotal && items.length > 0;
      categoryPrefetch = null;
      if (categoryHasMore) prefetchCategoryPage(currentCategoryId, categoryOffset, limit);
      if (progress) {
        const shownProducts = Math.min(categoryOffset, categoryTotal);
        progress.textContent = categoryHasMore ? `${shownProducts} de ${categoryTotal} productos cargados` : `${categoryTotal} productos`;
      }
    } catch (error) {
      if (progress) progress.textContent = 'No se pudieron cargar más productos.';
      notify(error.message);
    } finally {
      categoryLoading = false;
    }
  }

  function syncSearchClear() {
    if (!searchClear || !searchInput) return;
    searchClear.hidden = searchInput.value.length === 0;
  }

  function clearSearch() {
    clearTimeout(searchTimer);
    if (searchController) {
      searchController.abort();
      searchController = null;
    }
    searchInput.value = '';
    syncSearchClear();
    renderRootCategories();
    searchInput.focus();
  }

  async function runSearch(query) {
    mode = 'search';
    enterBrowseMode();
    categoryHasMore = false;
    categoryPrefetch = null;
    if (searchController) searchController.abort();
    searchController = new AbortController();
    browser.innerHTML = '<div class="gq__loading">Buscando…</div>';
    try {
      const payload = await request('search', { q: query }, 'GET', { signal: searchController.signal });
      const items = Array.isArray(payload.items) ? payload.items : [];
      warmProductImages(items, 2);
      const exact = items.find((item) => {
        const values = [item.reference, item.ean13].concat((item.variants || []).flatMap((v) => [v.reference, v.ean13])).filter(Boolean).map(String);
        return values.some((value) => value.toLowerCase() === String(query).toLowerCase());
      });
      if (exact && /^[0-9A-Za-z._-]{4,}$/.test(query)) {
        let attr = Number(exact.attributeId || 0);
        const variant = (exact.variants || []).find((v) => [v.reference, v.ean13].filter(Boolean).some((x) => String(x).toLowerCase() === String(query).toLowerCase()));
        if (variant) attr = Number(variant.id || 0);
        await cartAction('add', { idProduct: Number(exact.id), idAttribute: attr }, 'Producto añadido.');
        searchInput.value = '';
        syncSearchClear();
        renderRootCategories();
        searchInput.focus();
        return;
      }
      browser.innerHTML = `<div class="gq__toolbar"><span class="gq__toolbar-title">Resultados</span></div><div class="gq__product-grid">${items.length ? items.map((item, index) => productCard(item, index < 2)).join('') : '<p class="gq__muted">No se encontraron productos.</p>'}</div>`;
    } catch (error) {
      if (error.name !== 'AbortError') {
        browser.innerHTML = '<div class="gq__loading">No se pudo realizar la búsqueda.</div>';
        notify(error.message);
      }
    }
  }

  function renderCart(cart) {
    const lines = Array.isArray(cart.lines) ? cart.lines : [];
    cartCount.textContent = String(Number(cart.count || 0));
    if (mobileCount) mobileCount.textContent = String(Number(cart.count || 0));
    cartLines.innerHTML = lines.length ? lines.map((line) => `
      <div class="gq__line">
        ${line.imageUrl ? `<img class="gq__line-image" src="${esc(line.imageUrl)}" alt="${esc(line.name)}" loading="lazy" decoding="async">` : '<span class="gq__line-image"></span>'}
        <div>
          <div class="gq__line-top"><span class="gq__line-name">${esc(line.name)}</span><strong>${money.format(Number(line.total))}</strong></div>
          <div class="gq__line-meta">${esc(line.reference || '')}${line.reference ? ' · ' : ''}${money.format(Number(line.unitPrice))} / ud.</div>
          <div class="gq__line-actions">
            <button type="button" class="btn btn-outline-secondary btn-sm gq__mini" data-decrease-product="${Number(line.id)}" data-attribute="${Number(line.attributeId || 0)}">−</button>
            <input class="gq__qty-input" type="number" min="1" max="${Math.max(1,Number(line.stock || 999))}" value="${Number(line.quantity)}" data-set-quantity-product="${Number(line.id)}" data-attribute="${Number(line.attributeId || 0)}" aria-label="Cantidad">
            <button type="button" class="btn btn-outline-secondary btn-sm gq__mini" data-increase-product="${Number(line.id)}" data-attribute="${Number(line.attributeId || 0)}">+</button>
            <button type="button" class="btn btn-outline-danger btn-sm gq__mini gq__remove" data-remove-product="${Number(line.id)}" data-attribute="${Number(line.attributeId || 0)}" title="Eliminar">×</button>
          </div>
        </div>
      </div>`).join('') : '<p class="gq__muted gq__empty">El carrito está vacío.</p>';

    productsTotal.textContent = money.format(Number(cart.productsTotal || 0));
    discountsTotal.textContent = `−${money.format(Number(cart.discountsTotal || 0))}`;
    shippingTotal.textContent = money.format(Number(cart.shippingTotal || 0));
    totalNode.textContent = money.format(Number(cart.total || 0));
    if (mobileTotal) mobileTotal.textContent = money.format(Number(cart.total || 0));
    discountRow.hidden = Number(cart.discountsTotal || 0) <= 0;
    shippingRow.hidden = Number(cart.shippingTotal || 0) <= 0;

    const coupons = Array.isArray(cart.coupons) ? cart.coupons : [];
    if (stepCoupon) stepCoupon.textContent = coupons.length ? (coupons[0].code || coupons[0].name || 'Aplicado') : 'No aplicado';
    couponsNode.innerHTML = coupons.map((coupon) => `
      <div class="gq__coupon-chip"><span>${esc(coupon.code || coupon.name)}${Number(coupon.value) > 0 ? ` · −${money.format(Number(coupon.value))}` : ''}</span><button type="button" class="btn btn-link btn-sm" data-remove-coupon="${Number(coupon.id)}">Quitar</button></div>`).join('');

    const availableCoupons = Array.isArray(cart.availableCoupons) ? cart.availableCoupons : [];
    if (availableCouponsNode) {
      availableCouponsNode.innerHTML = availableCoupons.length
        ? `<small class="gq__available-coupons-title">Vales disponibles</small><div class="gq__available-coupon-list">${availableCoupons.map((coupon) => {
            const benefit = coupon.benefit || (Number(coupon.amount) > 0 ? money.format(Number(coupon.amount)) : '');
            return `<button type="button" class="gq__available-coupon" data-apply-available-coupon="${esc(coupon.code)}"><strong>${esc(coupon.code)}</strong><span>${esc(coupon.name || '')}${benefit ? ` · ${esc(benefit)}` : ''}</span></button>`;
          }).join('')}</div>`
        : '';
    }

    const freeShipping = cart.freeShipping && typeof cart.freeShipping === 'object' ? cart.freeShipping : null;
    if (freeShippingProgressNode) {
      if (!freeShipping || !lines.length) {
        freeShippingProgressNode.hidden = true;
        freeShippingProgressNode.innerHTML = '';
      } else {
        freeShippingProgressNode.hidden = false;
        const percent = Math.max(0, Math.min(100, Number(freeShipping.percent || 0)));
        const text = freeShipping.reached
          ? '✓ Ya tienes envío gratuito'
          : `Te faltan ${money.format(Number(freeShipping.remaining || 0))} para envío gratuito`;
        const suggestions = Array.isArray(cart.freeShippingSuggestions) ? cart.freeShippingSuggestions : [];
        const suggestionHtml = !freeShipping.reached && suggestions.length
          ? `<div class="gq__shipping-suggestions"><small>Completa tu pedido</small><div>${suggestions.map((item) => `<button type="button" class="gq__shipping-suggestion" data-add-product="${Number(item.id)}" data-add-attribute="${Number(item.attributeId || 0)}">${item.imageUrl ? `<img class="gq__shipping-suggestion-image" src="${esc(item.imageUrl)}" alt="" loading="lazy" decoding="async">` : '<span class="gq__shipping-suggestion-image gq__shipping-suggestion-image--empty"></span>'}<span class="gq__shipping-suggestion-copy"><span class="gq__shipping-suggestion-name">${esc(item.name)}</span>${item.personalizationReason ? `<small>${esc(item.personalizationReason)}</small>` : ''}</span><strong>${money.format(Number(item.price || 0))}</strong>${iconSvg('cart')}</button>`).join('')}</div></div>`
          : '';
        freeShippingProgressNode.innerHTML = `<div class="gq__free-shipping-text">${esc(text)}</div><div class="gq__free-shipping-track"><span style="width:${percent}%"></span></div>${suggestionHtml}`;
      }
    }

    cartHasLines = lines.length > 0;
    updateCheckoutState();

    if (window.prestashop && typeof window.prestashop.emit === 'function') {
      window.prestashop.emit('updatedCart', { reason: { linkAction: 'ganeshpos-quickorder' }, resp: { cart } });
    }
  }

  async function refreshCart() {
    try {
      const payload = await request('cart');
      renderCart(payload.cart || {});
    } catch (error) {
      notify(error.message);
    }
  }

  async function cartAction(action, params, successMessage = '') {
    try {
      const payload = await request(action, params, 'POST');
      renderCart(payload.cart || {});
      await refreshCarriers();
      await refreshPayments();
      if (successMessage) notify(successMessage, 'success');
      return payload;
    } catch (error) {
      notify(error.message);
      return null;
    }
  }

  function renderCustomer(customer) {
    if (!customerAccess || !customer || !customer.logged) return;
    if (stepCustomer) stepCustomer.textContent = customer.name || 'Cliente';
    customerAccess.innerHTML = `
      <span class="gq__summary-icon gq__summary-icon--blue">${iconSvg('user')}</span>
      <div class="gq__customer-info">
        <span class="gq__customer-label">Cliente</span>
        <strong>${esc(customer.name)}</strong>
        <small>${esc(customer.email)}</small>
      </div>
      <button id="gq-account-open" class="btn btn-outline-secondary btn-sm" type="button">Mi cuenta</button>`;
    if (addressAccess) addressAccess.hidden = false;
    if (mode === 'categories' && searchInput?.value.trim() === '') renderHomeSections();
  }

  function renderAddresses(items, selectedId = 0) {
    if (!addressAccess || !addressSelect) return;
    const addresses = Array.isArray(items) ? items : [];
    addressAccess.hidden = false;
    addressSelect.innerHTML = addresses.length
      ? addresses.map((item) => `<option value="${Number(item.id)}" ${Number(item.id) === Number(selectedId) ? 'selected' : ''}>${esc(item.alias)} · ${esc(item.label)}</option>`).join('')
      : '<option value="0">Sin direcciones. Crea una nueva.</option>';
    addressEdit.disabled = !addresses.length;
    const selectedAddress = addresses.find((item) => Number(item.id) === Number(selectedId)) || addresses[0];
    if (stepAddress) stepAddress.textContent = selectedAddress ? (selectedAddress.alias || selectedAddress.label || 'Seleccionada') : 'Pendiente';
  }

  function clearCheckoutGuidance() {
    document.querySelectorAll('.gq__needs-attention').forEach((node) => node.classList.remove('gq__needs-attention'));
  }

  function guideToCheckoutRequirement(section, control, message, stepSelector = '') {
    clearCheckoutGuidance();
    if (section) section.classList.add('gq__needs-attention');
    if (control) control.classList.add('gq__needs-attention');
    if (stepSelector) document.querySelector(stepSelector)?.classList.add('gq__needs-attention');
    if (window.matchMedia('(max-width: 767px)').matches) openMobileCart();
    window.setTimeout(() => {
      const target = control || section;
      target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (control && typeof control.focus === 'function') {
        try { control.focus({ preventScroll: true }); } catch (_) { control.focus(); }
      }
    }, 80);
    notify(message, 'warning');
  }

  function validateCheckoutRequirements() {
    clearCheckoutGuidance();
    if (!cartHasLines) {
      notify('Añade al menos un producto antes de finalizar la compra.', 'warning');
      return false;
    }

    const customerLogged = addressAccess && !addressAccess.hidden;
    if (!customerLogged) {
      const loginButton = customerAccess?.querySelector('#gq-login-open');
      const registerButton = customerAccess?.querySelector('#gq-register-open');
      guideToCheckoutRequirement(
        customerAccess,
        loginButton || registerButton || customerAccess,
        'Para finalizar, inicia sesión o crea una cuenta.',
        '.gq__step--customer'
      );
      return false;
    }

    if (!addressSelect || Number(addressSelect.value || 0) <= 0) {
      guideToCheckoutRequirement(
        addressAccess,
        addressSelect || addressNew || addressAccess,
        'Selecciona una dirección de entrega o crea una nueva.',
        '.gq__step--address'
      );
      return false;
    }

    if (!carrierSelect || String(carrierSelect.value || '') === '') {
      guideToCheckoutRequirement(
        carrierWrap,
        carrierSelect || carrierWrap,
        'Selecciona un transportista para continuar.',
        '.gq__step--carrier'
      );
      return false;
    }

    if (!paymentSelect || selectedPaymentId === '' || String(paymentSelect.value || '') === '') {
      guideToCheckoutRequirement(
        paymentWrap,
        paymentSelect || paymentWrap,
        'Selecciona un método de pago para continuar.',
        '.gq__step--payment'
      );
      return false;
    }

    return true;
  }

  function updateCheckoutState() {
    if (!checkoutButton) return;
    // El botón se mantiene disponible cuando hay productos para poder guiar al
    // cliente hasta cualquier dato pendiente (cuenta, dirección, transporte o pago).
    const readyToReview = cartHasLines && !paymentProcessing;
    checkoutButton.classList.toggle('disabled', !readyToReview);
    checkoutButton.setAttribute('aria-disabled', readyToReview ? 'false' : 'true');
    if (mobileCheckout) mobileCheckout.disabled = !cartHasLines;
    // Keep the native checkout URL only as a no-JS fallback. With JS enabled we
    // hand off directly to the selected payment module.
    checkoutButton.href = checkoutBaseUrl;
  }

  function renderPaymentOptions(items) {
    if (!paymentSelect || !paymentWrap) return;
    const rows = Array.isArray(items) ? items : [];
    const validIds = rows.map((item) => String(item.id || ''));
    if (!validIds.includes(selectedPaymentId)) selectedPaymentId = rows.length ? String(rows[0].id || '') : '';
    paymentSelect.innerHTML = rows.length
      ? rows.map((item) => `<option value="${esc(item.id)}" ${String(item.id) === selectedPaymentId ? 'selected' : ''}>${esc(item.name)}</option>`).join('')
      : '<option value="">No hay métodos de pago disponibles</option>';
    paymentSelect.disabled = !rows.length;
    paymentHelp.textContent = rows.length
      ? `${rows.length} método${rows.length === 1 ? '' : 's'} disponible${rows.length === 1 ? '' : 's'}.`
      : 'No hay métodos de pago disponibles para este carrito.';
    const selectedPayment = rows.find((item) => String(item.id) === selectedPaymentId) || rows[0];
    if (stepPayment) stepPayment.textContent = selectedPayment ? selectedPayment.name : 'Pendiente';
    updateCheckoutState();
  }

  async function refreshPayments() {
    if (!paymentSelect || !paymentWrap) return;
    if (!cartHasLines) {
      selectedPaymentId = '';
      paymentSelect.innerHTML = '<option value="">Añade productos para ver los métodos de pago</option>';
      paymentSelect.disabled = true;
      paymentHelp.textContent = 'Al finalizar se abrirá directamente el método de pago elegido.';
      updateCheckoutState();
      return;
    }
    paymentSelect.disabled = true;
    paymentSelect.innerHTML = '<option value="">Calculando métodos de pago…</option>';
    try {
      const payload = await request('payments');
      renderPaymentOptions(payload.items || []);
    } catch (error) {
      selectedPaymentId = '';
      paymentSelect.innerHTML = '<option value="">Error al cargar métodos de pago</option>';
      paymentSelect.disabled = true;
      paymentHelp.textContent = error.message || 'No se pudieron cargar los métodos de pago.';
      updateCheckoutState();
    }
  }

  function closePaymentModal() {
    if (!paymentModal) return;
    paymentModal.hidden = true;
    if (paymentContent) paymentContent.innerHTML = '';
    document.documentElement.classList.remove('gq-modal-open');
  }

  function setHtmlWithScripts(node, html) {
    if (!node) return;
    node.innerHTML = html;
    node.querySelectorAll('script').forEach((oldScript) => {
      const script = document.createElement('script');
      Array.from(oldScript.attributes).forEach((attr) => script.setAttribute(attr.name, attr.value));
      script.text = oldScript.text || oldScript.textContent || '';
      oldScript.replaceWith(script);
    });
  }

  function submitPaymentAction(payment) {
    const action = String(payment.action || '');
    if (!action) return false;
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = action;
    form.style.display = 'none';
    (Array.isArray(payment.inputs) ? payment.inputs : []).forEach((item) => {
      const input = document.createElement('input');
      input.type = item.type || 'hidden';
      input.name = item.name || '';
      input.value = item.value || '';
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    return true;
  }

  function openPaymentForm(payment) {
    if (!paymentModal || !paymentContent) return false;
    const additional = String(payment.additionalInformation || '');
    const formHtml = String(payment.form || '');
    if (!additional && !formHtml) return false;
    paymentModal.hidden = false;
    document.documentElement.classList.add('gq-modal-open');
    setHtmlWithScripts(paymentContent, `${additional}${formHtml}`);

    const forms = Array.from(paymentContent.querySelectorAll('form'));
    if (forms.length === 1) {
      const visibleFields = forms[0].querySelectorAll('input:not([type="hidden"]):not([type="submit"]):not([type="button"]), select, textarea, iframe');
      if (visibleFields.length === 0) {
        window.setTimeout(() => forms[0].requestSubmit ? forms[0].requestSubmit() : forms[0].submit(), 0);
      }
    }
    return true;
  }

  async function handoffToPayment() {
    if (!selectedPaymentId || paymentProcessing) return;
    paymentProcessing = true;
    const previousText = checkoutButton?.textContent || 'Finalizar compra';
    if (checkoutButton) checkoutButton.textContent = 'Procesando pago…';
    updateCheckoutState();
    try {
      const payload = await request('paymentHandoff', { paymentId: selectedPaymentId }, 'POST');
      const payment = payload.payment || {};

      // Standard PrestaShop PaymentOption: submit its action + inputs directly.
      if (!payment.form && submitPaymentAction(payment)) return;

      // Some payment modules expose their own form / embedded fields. Show only
      // that payment flow inside Compra rápida, never the payment-selection step.
      if (openPaymentForm(payment)) return;

      // Rare binary/special integrations cannot be reproduced generically. The
      // selected option is preserved as a compatibility fallback.
      if (payment.fallbackUrl) {
        window.location.assign(payment.fallbackUrl);
        return;
      }
      throw new Error('Este método de pago no permite iniciar el pago directamente.');
    } catch (error) {
      paymentProcessing = false;
      if (checkoutButton) checkoutButton.textContent = previousText;
      updateCheckoutState();
      notify(error.message || 'No se pudo iniciar el pago.');
    }
  }

  async function refreshAddresses() {
    if (!addressAccess || addressAccess.hidden) return;
    try {
      const payload = await request('addresses');
      renderAddresses(payload.addresses || [], payload.selectedId || 0);
    } catch (_) {}
  }

  function renderCarriers(items, selectedKey = '') {
    if (!carrierSelect || !carrierWrap) return;
    const rows = Array.isArray(items) ? items : [];
    carrierSelect.innerHTML = rows.length
      ? rows.map((item) => {
          const delivery = item.deliveryText ? ` · ${esc(item.deliveryText)}` : '';
          return `<option value="${esc(item.key)}" ${String(item.key) === String(selectedKey) ? 'selected' : ''}>${esc(item.name)} · ${money.format(Number(item.price || 0))}${delivery}</option>`;
        }).join('')
      : '<option value="">No hay transportistas disponibles</option>';
    carrierSelect.disabled = !rows.length;
    const selectedCarrier = rows.find((item) => String(item.key) === String(selectedKey)) || rows[0];
    carrierHelp.textContent = selectedCarrier
      ? `${rows.length} opción${rows.length === 1 ? '' : 'es'} de envío disponible${rows.length === 1 ? '' : 's'}.${selectedCarrier.deliveryText ? ` ${selectedCarrier.deliveryText}.` : ''}`
      : 'No hay transporte disponible para esta dirección y carrito.';
    if (stepCarrier) stepCarrier.textContent = selectedCarrier ? `${selectedCarrier.name}` : 'Por calcular';
  }

  async function refreshCarriers() {
    if (!carrierSelect || !carrierWrap || !addressAccess || addressAccess.hidden) return;
    carrierSelect.disabled = true;
    carrierSelect.innerHTML = '<option value="">Calculando transportistas…</option>';
    carrierHelp.textContent = '';
    try {
      const payload = await request('carriers');
      renderCarriers(payload.items || [], payload.selectedKey || '');
      if (payload.cart) renderCart(payload.cart || {});
    } catch (error) {
      carrierSelect.innerHTML = '<option value="">Error al calcular transporte</option>';
      carrierSelect.disabled = true;
      carrierHelp.textContent = error.message || 'No se pudo calcular el transporte.';
    }
  }

  function openAddressModal() {
    addressModal.hidden = false;
    document.documentElement.classList.add('gq-modal-open');
    window.setTimeout(() => addressAlias?.focus(), 0);
  }

  function closeAddressModal() {
    if (!addressModal) return;
    addressModal.hidden = true;
    if ((!loginModal || loginModal.hidden) && (!registerModal || registerModal.hidden)) {
      document.documentElement.classList.remove('gq-modal-open');
    }
  }

  function renderCountryOptions(countries, selectedId) {
    addressCountry.innerHTML = (countries || []).map((country) => `<option value="${Number(country.id)}" ${Number(country.id) === Number(selectedId) ? 'selected' : ''}>${esc(country.name)}</option>`).join('');
  }

  function renderStateOptions(states, selectedId, required) {
    const rows = Array.isArray(states) ? states : [];
    addressStateWrap.hidden = rows.length === 0;
    addressState.required = !!required && rows.length > 0;
    addressState.innerHTML = rows.length
      ? `<option value="">Seleccionar…</option>${rows.map((state) => `<option value="${Number(state.id)}" ${Number(state.id) === Number(selectedId) ? 'selected' : ''}>${esc(state.name)}</option>`).join('')}`
      : '<option value="0">No aplicable</option>';
  }

  function setAddressFormLoading(loading) {
    if (!addressForm) return;
    addressForm.querySelectorAll('input, select, button').forEach((node) => {
      if (node.id === 'gq-address-id') return;
      node.disabled = !!loading;
    });
    addressForm.classList.toggle('gq__address-form--loading', !!loading);
  }

  function resetAddressFormForNew() {
    if (!addressForm) return;
    addressId.value = '0';
    addressAlias.value = 'Mi dirección';
    addressPhone.value = '';
    addressLine1.value = '';
    addressLine2.value = '';
    addressPostcode.value = '';
    addressCity.value = '';
    addressCountry.innerHTML = '<option value="">Cargando países…</option>';
    addressState.innerHTML = '<option value="0">Cargando…</option>';
    addressStateWrap.hidden = false;
  }

  async function loadAddressForm(id = 0, idCountry = 0) {
    if (!addressModal || !addressForm) throw new Error('No se pudo abrir el formulario de dirección.');
    if (Number(id) <= 0) resetAddressFormForNew();
    openAddressModal();
    setAddressFormLoading(true);
    try {
      const payload = await request('addressMeta', { idAddress: id, idCountry });
      const data = payload.address || {};
      addressId.value = Number(data.id || 0);
      addressAlias.value = data.alias || 'Mi dirección';
      addressPhone.value = data.phone || '';
      addressLine1.value = data.address1 || '';
      addressLine2.value = data.address2 || '';
      addressPostcode.value = data.postcode || '';
      addressCity.value = data.city || '';
      renderCountryOptions(payload.countries || [], Number(data.idCountry || idCountry || 0));
      renderStateOptions(payload.states || [], Number(data.idState || 0), payload.stateRequired);
    } catch (error) {
      notify(error.message || 'No se pudieron cargar los datos de la dirección.');
      throw error;
    } finally {
      setAddressFormLoading(false);
      window.setTimeout(() => addressAlias?.focus(), 0);
    }
  }

  function closeQuickViewModal() {
    if (!quickViewModal) return;
    quickViewModal.hidden = true;
    if ((!loginModal || loginModal.hidden) && (!registerModal || registerModal.hidden) && (!addressModal || addressModal.hidden) && (!paymentModal || paymentModal.hidden) && (!accountModal || accountModal.hidden)) {
      document.documentElement.classList.remove('gq-modal-open');
    }
  }

  function quickViewVariantOptions(variants, selectedId) {
    if (!Array.isArray(variants) || variants.length <= 1) return '';
    return `<label class="gq__quickview-variant-label" for="gq-quickview-variant">Variante</label><select id="gq-quickview-variant" class="form-control gq__quickview-variant" data-quickview-variant>${variants.map((variant) => `<option value="${Number(variant.id)}" data-price="${Number(variant.price || 0)}" data-stock="${Number(variant.stock || 0)}" data-ref="${esc(variant.reference || variant.ean13 || '')}" ${Number(variant.id) === Number(selectedId) ? 'selected' : ''}>${esc(variant.name || variant.reference || `Variante ${variant.id}`)}</option>`).join('')}</select>`;
  }

  function quickViewRelatedBlock(items, title, kind) {
    const rows = Array.isArray(items) ? items.filter((item) => item && Number(item.id) > 0) : [];
    if (!rows.length) return '';
    return `<section class="gq__quickview-related"><h4>${esc(title)}</h4><div class="gq__quickview-related-grid">${rows.map((item) => {
      const variants = Array.isArray(item.variants) ? item.variants : [];
      const selected = variants.find((variant) => Number(variant.id) === Number(item.attributeId || 0)) || variants[0] || null;
      const attr = Number(selected?.id ?? item.attributeId ?? 0);
      const price = Number(selected?.price ?? item.price ?? 0);
      const stock = Number(selected?.stock ?? item.stock ?? 0);
      return `<article class="gq__quickview-related-item"><span class="gq__quickview-related-image">${item.imageUrl ? `<img src="${esc(item.imageUrl)}" alt="${esc(item.name || '')}" loading="lazy" decoding="async">` : ''}</span><span class="gq__quickview-related-copy"><strong>${esc(item.name || '')}</strong><small>${money.format(price)} · ${stock > 0 ? 'En stock' : 'Agotado'}</small></span><button type="button" class="gq__quickview-related-add" data-quickview-related-add="${Number(item.id)}" data-add-attribute="${attr}" ${stock <= 0 ? 'disabled' : ''} aria-label="Añadir ${esc(item.name || '')}">${iconSvg('cart')}</button></article>`;
    }).join('')}</div></section>`;
  }

  function renderQuickView(product) {
    if (!quickViewContent || !product) return;
    const images = Array.isArray(product.images) ? product.images.filter((image) => image && image.url) : [];
    const mainImage = images[0]?.url || '';
    const selectedVariant = (product.variants || []).find((variant) => Number(variant.id) === Number(product.attributeId || 0));
    const reference = selectedVariant?.reference || product.reference || selectedVariant?.ean13 || product.ean13 || `#${product.id}`;
    const price = Number(selectedVariant?.price ?? product.price ?? 0);
    const stock = Number(selectedVariant?.stock ?? product.stock ?? 0);
    const gallery = mainImage
      ? `<div class="gq__quickview-gallery"><div class="gq__quickview-main"><img id="gq-quickview-main-image" src="${esc(mainImage)}" alt="${esc(product.name)}" decoding="async"></div>${images.length > 1 ? `<div class="gq__quickview-thumbs">${images.map((image, index) => `<button type="button" class="gq__quickview-thumb ${index === 0 ? 'is-active' : ''}" data-quickview-image="${esc(image.url)}" aria-label="Ver imagen ${index + 1}"><img src="${esc(image.url)}" alt="" loading="lazy" decoding="async"></button>`).join('')}</div>` : ''}</div>`
      : '<div class="gq__quickview-gallery"><div class="gq__quickview-main gq__quickview-main--empty">Sin imagen</div></div>';
    const description = String(product.description || product.shortDescription || '').trim();
    const details = Array.isArray(product.details) ? product.details.filter((detail) => detail && detail.label && detail.value) : [];
    const descriptionBlock = description ? `<section class="gq__quickview-section"><h4>Descripción</h4><div class="gq__quickview-description">${esc(description)}</div></section>` : '';
    const detailsBlock = details.length ? `<section class="gq__quickview-section"><h4>Detalles del producto</h4><dl class="gq__quickview-details">${details.map((detail) => `<div class="gq__quickview-detail"><dt>${esc(detail.label)}</dt><dd>${esc(detail.value)}</dd></div>`).join('')}</dl></section>` : '';
    const alternativesBlock = quickViewRelatedBlock(product.alternatives || [], 'Alternativas disponibles', 'alternative');
    const complementsBlock = quickViewRelatedBlock(product.complements || [], 'También puedes necesitar', 'complement');
    const availability = stock <= 0 ? '<div class="gq__quickview-out"><strong>Producto agotado.</strong> Consulta las alternativas disponibles más abajo.</div>' : '';
    const watchState = product.watchState && typeof product.watchState === 'object' ? product.watchState : {};
    const alerts = `<div class="gq__product-alerts">${stock <= 0 ? `<button type="button" class="gq__product-alert ${watchState.stock ? 'is-active' : ''}" data-product-watch="stock" data-watch-product="${Number(product.id)}" data-watch-attribute="${Number(product.attributeId || 0)}">${watchState.stock ? '✓ Aviso de reposición activo' : '🔔 Avísame cuando haya stock'}</button>` : ''}<button type="button" class="gq__product-alert ${watchState.price ? 'is-active' : ''}" data-product-watch="price" data-watch-product="${Number(product.id)}" data-watch-attribute="${Number(product.attributeId || 0)}">${watchState.price ? '✓ Aviso de precio activo' : '↓ Avisarme si baja de precio'}</button></div>`;
    quickViewContent.innerHTML = `<div class="gq__quickview-layout">${gallery}<div class="gq__quickview-info"><h3>${esc(product.name)}</h3><div class="gq__quickview-meta">Referencia: <strong data-quickview-ref>${esc(reference)}</strong> · Stock: <strong data-quickview-stock>${stock}</strong></div>${availability}${quickViewVariantOptions(product.variants || [], product.attributeId || 0)}<div class="gq__quickview-buy"><strong class="gq__quickview-price" data-quickview-price>${money.format(price)}</strong><button type="button" class="btn btn-primary gq__quickview-add" data-quickview-add="${Number(product.id)}" data-add-attribute="${Number(product.attributeId || 0)}" ${stock <= 0 ? 'disabled' : ''}>＋ Añadir al carrito</button></div>${alerts}${alternativesBlock}${complementsBlock}${descriptionBlock}${detailsBlock}${product.url ? `<a class="gq__quickview-full-link" href="${esc(product.url)}">Ver ficha completa</a>` : ''}</div></div>`;
  }

  async function openQuickView(idProduct, idAttribute = 0) {
    if (!quickViewModal || !quickViewContent) return;
    quickViewModal.hidden = false;
    document.documentElement.classList.add('gq-modal-open');
    quickViewContent.innerHTML = '<div class="gq__quickview-loading">Cargando producto…</div>';
    try {
      const payload = await request('productQuickView', { idProduct: Number(idProduct), idAttribute: Number(idAttribute || 0), deviceId: pwaDeviceId() });
      renderQuickView(payload.product || null);
      request('recordProductView', { idProduct: Number(idProduct), idAttribute: Number(payload.product?.attributeId || idAttribute || 0), deviceId: pwaDeviceId() }, 'POST').then(() => {
        clearResponseCache();
        ['recent','foryou'].forEach((type) => {
          const section = (homeSections || document).querySelector?.(`[data-showcase="${type}"]`);
          const body = section?.querySelector('[data-showcase-body]');
          if (body) { body.dataset.loaded = '0'; if (!body.hidden) body.innerHTML = '<div class="gq__loading">Actualizando…</div>'; }
        });
      }).catch(() => {});
      warmImageUrls((payload.product?.images || []).map((image) => image?.url));
    } catch (error) {
      quickViewContent.innerHTML = `<div class="gq__quickview-error">${esc(error.message || 'No se pudo cargar el producto.')}</div>`;
    }
  }

  function openAccountModal() {
    if (!accountModal || !accountFrame) return;
    accountModal.hidden = false;
    document.documentElement.classList.add('gq-modal-open');
    if (!accountFrame.getAttribute('src')) {
      if (accountLoading) accountLoading.hidden = false;
      accountFrame.setAttribute('src', accountFrame.dataset.src || accountUrl);
    }
  }

  function closeAccountModal() {
    if (!accountModal) return;
    accountModal.hidden = true;
    document.documentElement.classList.remove('gq-modal-open');
  }

  accountFrame?.addEventListener('load', () => {
    if (accountLoading) accountLoading.hidden = true;
  });

  function openAuthModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('gq-modal-open');
    window.setTimeout(() => modal.querySelector('input:not([type="hidden"])')?.focus(), 0);
  }

  function closeAuthModal(modal) {
    if (!modal) return;
    modal.hidden = true;
    if ((!loginModal || loginModal.hidden) && (!registerModal || registerModal.hidden)) {
      document.documentElement.classList.remove('gq-modal-open');
    }
  }

  async function refreshAuthenticatedState(initialPayload = {}) {
    const state = initialPayload || {};

    if (state.token) {
      token = String(state.token);
      root.dataset.token = token;
    }

    if (!state.customer || !state.customer.logged) {
      return false;
    }

    // The login/register response now contains a fully initialized authenticated
    // Context, including addresses and cart. Apply it immediately. There is no
    // separate "session confirmation" phase anymore, which previously caused
    // protected address requests to race against the just-created login cookie.
    renderCustomer(state.customer);
    renderAddresses(
      Array.isArray(state.addresses) ? state.addresses : [],
      Number(state.selectedAddressId || state.customer.addressId || 0)
    );
    if (state.cart) {
      try { renderCart(state.cart); } catch (_) {}
    }
    updateCheckoutState();

    // By the time fetch() resolves, Set-Cookie from the login response has been
    // processed by the browser. The following requests can safely use the new
    // authenticated cookie. Keep failures local so a carrier/payment issue can
    // never turn a successful login back into a "debes iniciar sesión" error.
    try { await refreshCarriers(); } catch (error) {
      console.warn('Ganesh POS: no se pudieron refrescar transportistas tras el login.', error);
    }
    try { await refreshPayments(); } catch (error) {
      console.warn('Ganesh POS: no se pudieron refrescar pagos tras el login.', error);
    }
    try { await refreshCart(); } catch (error) {
      console.warn('Ganesh POS: no se pudo refrescar el carrito tras el login.', error);
    }
    updateCheckoutState();
    return true;
  }

  async function submitAuthForm(action, form, wrap, modal) {
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    const body = new URLSearchParams();
    body.set('ajax', '1');
    body.set('action', action);
    body.set('token', token);
    for (const [key, value] of new FormData(form).entries()) {
      body.append(key, String(value));
    }
    try {
      const response = await fetch(ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8', Accept: 'application/json' },
        body,
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload.ok === false) {
        if (payload.formHtml && wrap) wrap.innerHTML = payload.formHtml;
        throw new Error(payload.error || `HTTP ${response.status}`);
      }

      // In PrestaShop 9 the authentication cookie is already persisted when the
      // login form succeeds, but the legacy Context of the same AJAX request can
      // still represent the anonymous visitor. For login, rebuild the page with a
      // fresh FrontController request instead of issuing protected AJAX calls with
      // that stale context. This is automatic and avoids false session errors.
      clearResponseCache();
      closeAuthModal(modal);
      if (action === 'login' && payload.reload) {
        clearCheckoutGuidance();
        notify('Sesión iniciada correctamente. Actualizando Compra rápida…', 'success');
        window.setTimeout(() => window.location.reload(), 120);
        return;
      }

      const refreshed = await refreshAuthenticatedState(payload);
      if (refreshed === 'reloading') return;
      if (refreshed) {
        clearCheckoutGuidance();
        notify(action === 'login' ? 'Sesión iniciada correctamente.' : 'Cuenta creada correctamente.', 'success');
      } else {
        window.location.reload();
      }
    } catch (error) {
      notify(error.message);
    } finally {
      if (submit && document.contains(submit)) submit.disabled = false;
    }
  }

  customerAccess?.addEventListener('click', (event) => {
    clearCheckoutGuidance();
    if (event.target.closest('#gq-login-open')) openAuthModal(loginModal);
    if (event.target.closest('#gq-register-open')) openAuthModal(registerModal);
    if (event.target.closest('#gq-account-open')) openAccountModal();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-quickview-close]')) {
      closeQuickViewModal();
      return;
    }
    if (event.target === quickViewModal) {
      closeQuickViewModal();
      return;
    }
    if (event.target.closest('[data-account-close]')) {
      closeAccountModal();
      return;
    }
    if (event.target === accountModal) {
      closeAccountModal();
      return;
    }
    if (event.target.closest('[data-auth-close]')) {
      closeAuthModal(event.target.closest('.gq__modal'));
      return;
    }
    if (event.target.closest('[data-address-close]')) {
      closeAddressModal();
      return;
    }
    if (event.target.closest('[data-payment-close]')) {
      closePaymentModal();
      paymentProcessing = false;
      if (checkoutButton) checkoutButton.textContent = 'Finalizar compra';
      updateCheckoutState();
      return;
    }
    if (event.target === addressModal) {
      closeAddressModal();
      return;
    }
    if (event.target.classList.contains('gq__modal')) closeAuthModal(event.target);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeQuickViewModal();
      closeAccountModal();
      closeAuthModal(loginModal);
      closeAuthModal(registerModal);
      closeAddressModal();
      closePaymentModal();
      paymentProcessing = false;
      if (checkoutButton) checkoutButton.textContent = 'Finalizar compra';
      updateCheckoutState();
    }
  });

  document.addEventListener('submit', (event) => {
    const loginForm = event.target.closest('#gq-login-form-wrap form');
    if (loginForm) {
      event.preventDefault();
      return void submitAuthForm('login', loginForm, $('gq-login-form-wrap'), loginModal);
    }
    const registerForm = event.target.closest('#gq-register-form-wrap form');
    if (registerForm) {
      event.preventDefault();
      return void submitAuthForm('register', registerForm, $('gq-register-form-wrap'), registerModal);
    }
  });

  addressSelect?.addEventListener('change', async () => {
    clearCheckoutGuidance();
    const id = Number(addressSelect.value || 0);
    if (!id) return;
    try {
      const payload = await request('addressSelect', { idAddress: id }, 'POST');
      renderAddresses(payload.addresses || [], payload.selectedId || id);
      renderCart(payload.cart || {});
      await refreshCarriers();
      await refreshPayments();
      notify('Dirección de entrega actualizada.', 'success');
    } catch (error) {
      notify(error.message);
    }
  });

  addressNew?.addEventListener('click', async (event) => {
    event.preventDefault();
    try {
      await loadAddressForm(0);
    } catch (_) {}
  });

  addressEdit?.addEventListener('click', async (event) => {
    event.preventDefault();
    const id = Number(addressSelect?.value || 0);
    if (!id) return notify('Selecciona una dirección para editar.');
    try {
      await loadAddressForm(id);
    } catch (_) {}
  });

  addressCountry?.addEventListener('change', async () => {
    try {
      const payload = await request('addressMeta', { idCountry: Number(addressCountry.value || 0) });
      renderStateOptions(payload.states || [], 0, payload.stateRequired);
    } catch (error) {
      notify(error.message);
    }
  });

  addressForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = addressForm.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const payload = await request('addressSave', {
        idAddress: Number(addressId.value || 0),
        alias: addressAlias.value.trim(),
        phone: addressPhone.value.trim(),
        address1: addressLine1.value.trim(),
        address2: addressLine2.value.trim(),
        postcode: addressPostcode.value.trim(),
        city: addressCity.value.trim(),
        idCountry: Number(addressCountry.value || 0),
        idState: Number(addressState.value || 0),
      }, 'POST');
      renderAddresses(payload.addresses || [], payload.selectedId || 0);
      renderCart(payload.cart || {});
      await refreshCarriers();
      await refreshPayments();
      closeAddressModal();
      notify('Dirección guardada y seleccionada.', 'success');
    } catch (error) {
      notify(error.message);
    } finally {
      if (submit) submit.disabled = false;
    }
  });

  carrierSelect?.addEventListener('change', async () => {
    clearCheckoutGuidance();
    const key = String(carrierSelect.value || '');
    if (!key) return;
    if (stepCarrier) stepCarrier.textContent = carrierSelect.options[carrierSelect.selectedIndex]?.textContent?.split(' · ')[0] || 'Seleccionado';
    carrierSelect.disabled = true;
    try {
      const payload = await request('carrierSelect', { carrierKey: key }, 'POST');
      renderCart(payload.cart || {});
      carrierHelp.textContent = 'Transportista seleccionado.';
      await refreshPayments();
    } catch (error) {
      notify(error.message);
      await refreshCarriers();
    } finally {
      carrierSelect.disabled = false;
    }
  });

  paymentSelect?.addEventListener('change', () => {
    clearCheckoutGuidance();
    selectedPaymentId = String(paymentSelect.value || '');
    if (stepPayment) stepPayment.textContent = paymentSelect.options[paymentSelect.selectedIndex]?.textContent || 'Pendiente';
    updateCheckoutState();
  });

  checkoutButton?.addEventListener('click', (event) => {
    event.preventDefault();
    if (!cartHasLines || paymentProcessing) return;
    if (!validateCheckoutRequirements()) return;
    handoffToPayment();
  });

  homeSliderClose?.addEventListener('click', dismissHomeSlider);

  mobileCartOpen?.addEventListener('click', openMobileCart);
  mobileCartClose?.addEventListener('click', closeMobileCart);
  mobileOverlay?.addEventListener('click', closeMobileCart);
  mobileCheckout?.addEventListener('click', () => {
    // En móvil, el botón fijo "Finalizar" sirve primero para revisar el pedido.
    // El pago se confirma desde el botón "Finalizar compra" dentro del panel
    // desplegable de Tu pedido.
    openMobileCart();
  });

  interactionRoot.addEventListener('click', async (event) => {
    const fav = event.target.closest('[data-favorite-product]');
    if (fav) {
      event.preventDefault(); event.stopPropagation();
      try { const payload = await request('favoriteToggle', { idProduct: Number(fav.dataset.favoriteProduct), idAttribute: Number(fav.dataset.favoriteAttribute || 0) }, 'POST'); const key=String(payload.key||''); if(payload.favorite){favoriteKeys.add(key);fav.classList.add('is-active')}else{favoriteKeys.delete(key);fav.classList.remove('is-active')} notify(payload.favorite?'Añadido a Mis habituales.':'Quitado de Mis habituales.','success'); } catch(e){ notify(e.message); }
      return;
    }
    const repeat = event.target.closest('[data-repeat-order]');
    if (repeat) {
      repeat.disabled=true; try { const payload=await request('repeatOrder',{idOrder:Number(repeat.dataset.repeatOrder)},'POST'); if(payload.cart) renderCart(payload.cart); await refreshCarriers(); await refreshPayments(); notify(`${Number(payload.added||0)} productos añadidos del pedido.`,'success'); } catch(e){notify(e.message)} finally {repeat.disabled=false} return;
    }
    const showcaseToggle = event.target.closest('[data-showcase-toggle]');
    if (showcaseToggle) return void toggleShowcase(String(showcaseToggle.dataset.showcaseToggle || ''));
    const category = event.target.closest('[data-category]');
    if (category) return void renderCategory(Number(category.dataset.category));
    const back = event.target.closest('[data-category-back]');
    if (back) {
      const parentId = Number(back.dataset.categoryBack);
      return void (parentId === rootCategoryId ? renderRootCategories() : renderCategory(parentId));
    }
    if (event.target.closest('[data-category-home]')) return void renderRootCategories();
    const view = event.target.closest('[data-view-product]');
    if (view) {
      event.preventDefault(); event.stopPropagation();
      return void openQuickView(Number(view.dataset.viewProduct), Number(view.dataset.viewAttribute || 0));
    }
    const product = event.target.closest('[data-add-product]');
    if (product) {
      const card = product.closest('[data-product-card]');
      const qty = Math.max(1, Math.min(999, Number(card?.querySelector('[data-card-qty]')?.value || 1)));
      return void cartAction('add', { idProduct: product.dataset.addProduct, idAttribute: product.dataset.addAttribute || 0, quantity: qty });
    }
  });

  cartLines.addEventListener('click', (event) => {
    const inc = event.target.closest('[data-increase-product]');
    if (inc) return void cartAction('add', { idProduct: inc.dataset.increaseProduct, idAttribute: inc.dataset.attribute || 0, quantity: 1 });
    const dec = event.target.closest('[data-decrease-product]');
    if (dec) return void cartAction('decrease', { idProduct: dec.dataset.decreaseProduct, idAttribute: dec.dataset.attribute || 0 });
    const remove = event.target.closest('[data-remove-product]');
    if (remove) return void cartAction('remove', { idProduct: remove.dataset.removeProduct, idAttribute: remove.dataset.attribute || 0 });
  });

  cartLines.addEventListener('change', (event) => {
    const input = event.target.closest('[data-set-quantity-product]');
    if (!input) return;
    const desired = Math.max(1, Math.min(Number(input.max || 999), Number(input.value || 1)));
    const line = input.closest('.gq__line');
    const current = Number(line?.querySelector('[data-set-quantity-product]')?.defaultValue || input.defaultValue || desired);
    const delta = desired - current;
    if (delta === 0) return;
    input.disabled = true;
    const action = delta > 0 ? 'add' : 'decrease';
    cartAction(action, { idProduct: input.dataset.setQuantityProduct, idAttribute: input.dataset.attribute || 0, quantity: Math.abs(delta) });
  });

  quickViewContent?.addEventListener('click', async (event) => {
    const imageButton = event.target.closest('[data-quickview-image]');
    if (imageButton) {
      const main = $('gq-quickview-main-image');
      if (main) main.src = imageButton.dataset.quickviewImage || main.src;
      quickViewContent.querySelectorAll('[data-quickview-image]').forEach((button) => button.classList.toggle('is-active', button === imageButton));
      return;
    }
    const watch = event.target.closest('[data-product-watch]');
    if (watch) {
      watch.disabled = true;
      const type = String(watch.dataset.productWatch || '');
      try {
        const payload = await request('productWatchToggle', { idProduct: Number(watch.dataset.watchProduct), idAttribute: Number(watch.dataset.watchAttribute || 0), type, deviceId: pwaDeviceId() }, 'POST');
        clearResponseCache();
        watch.classList.toggle('is-active', Boolean(payload.active));
        watch.textContent = payload.active ? (type === 'stock' ? '✓ Aviso de reposición activo' : '✓ Aviso de precio activo') : (type === 'stock' ? '🔔 Avísame cuando haya stock' : '↓ Avisarme si baja de precio');
        notify(payload.active ? 'Aviso activado.' : 'Aviso desactivado.', 'success');
      } catch (error) {
        if (String(error?.message || '').includes('Activa los avisos') && isStandalonePwa()) {
          await enablePushNotifications({ auto: false });
          notify('Activa los avisos y vuelve a pulsar el botón de alerta.', 'success');
        } else {
          notify(error?.message || 'No se pudo guardar el aviso.');
        }
      } finally { watch.disabled = false; }
      return;
    }
    const relatedAdd = event.target.closest('[data-quickview-related-add]');
    if (relatedAdd) {
      relatedAdd.disabled = true;
      try {
        const payload = await cartAction('add', { idProduct: Number(relatedAdd.dataset.quickviewRelatedAdd), idAttribute: Number(relatedAdd.dataset.addAttribute || 0), quantity: 1 });
        if (payload) notify('Producto añadido al pedido.', 'success');
      } catch (error) { notify(error.message || 'No se pudo añadir el producto.'); }
      finally { relatedAdd.disabled = false; }
      return;
    }
    const addButton = event.target.closest('[data-quickview-add]');
    if (addButton) {
      addButton.disabled = true;
      const original = addButton.textContent;
      addButton.textContent = 'Añadiendo…';
      const payload = await cartAction('add', { idProduct: Number(addButton.dataset.quickviewAdd), idAttribute: Number(addButton.dataset.addAttribute || 0) });
      if (payload) {
        notify('Producto añadido al carrito.', 'success');
        closeQuickViewModal();
      } else {
        addButton.disabled = false;
        addButton.textContent = original;
      }
    }
  });

  quickViewContent?.addEventListener('change', (event) => {
    const select = event.target.closest('[data-quickview-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    if (!option) return;
    const attr = Number(option.value || 0);
    const price = Number(option.dataset.price || 0);
    const stock = Number(option.dataset.stock || 0);
    const ref = option.dataset.ref || '—';
    const priceNode = quickViewContent.querySelector('[data-quickview-price]');
    const stockNode = quickViewContent.querySelector('[data-quickview-stock]');
    const refNode = quickViewContent.querySelector('[data-quickview-ref]');
    const addButton = quickViewContent.querySelector('[data-quickview-add]');
    if (priceNode) priceNode.textContent = money.format(price);
    if (stockNode) stockNode.textContent = String(stock);
    if (refNode) refNode.textContent = ref;
    if (addButton) { addButton.dataset.addAttribute = String(attr); addButton.disabled = stock <= 0; }
    quickViewContent.querySelectorAll('[data-product-watch]').forEach((button) => { button.dataset.watchAttribute = String(attr); button.classList.remove('is-active'); if (button.dataset.productWatch === 'price') button.textContent = '↓ Avisarme si baja de precio'; });
  });


  freeShippingProgressNode?.addEventListener('click', (event) => {
    const product = event.target.closest('[data-add-product]');
    if (!product) return;
    product.disabled = true;
    cartAction('add', { idProduct: Number(product.dataset.addProduct), idAttribute: Number(product.dataset.addAttribute || 0), quantity: 1 }).finally(() => { product.disabled = false; });
  });

  couponApply.addEventListener('click', () => {
    const code = couponInput.value.trim();
    if (!code) return notify('Introduce un código de descuento.');
    cartAction('couponAdd', { code }).then(() => { couponInput.value = ''; });
  });

  couponInput.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      couponApply.click();
    }
  });

  couponsNode.addEventListener('click', (event) => {
    const button = event.target.closest('[data-remove-coupon]');
    if (button) cartAction('couponRemove', { idRule: button.dataset.removeCoupon });
  });

  availableCouponsNode?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-apply-available-coupon]');
    if (!button) return;
    const code = String(button.dataset.applyAvailableCoupon || '').trim();
    if (!code) return;
    button.disabled = true;
    cartAction('couponAdd', { code }).finally(() => { button.disabled = false; });
  });


  interactionRoot.addEventListener('change', (event) => {
    const select = event.target.closest('[data-variant-product]');
    if (!select) return;
    const card = select.closest('[data-product-card]'); const option = select.selectedOptions[0]; if (!card || !option) return;
    const attr=Number(option.value||0), price=Number(option.dataset.price||0), regularPrice=Number(option.dataset.regularPrice||price), discount=Number(option.dataset.discount||0), stock=Number(option.dataset.stock||0), ref=option.dataset.ref||`#${select.dataset.variantProduct}`;
    let tiers=[]; try{tiers=JSON.parse(option.dataset.tiers||'[]')}catch(_){tiers=[]}
    const imageUrl=String(option.dataset.image||'');
    card.querySelectorAll('[data-add-product]').forEach((b)=>{b.dataset.addAttribute=String(attr);b.disabled=stock<=0});
    if(imageUrl){const image=card.querySelector('.gq__product-img');if(image) image.src=imageUrl;}
    card.querySelectorAll('[data-view-product]').forEach((b)=>{b.dataset.viewAttribute=String(attr)});
    const fav=card.querySelector('[data-favorite-product]'); if(fav){fav.dataset.favoriteAttribute=String(attr);fav.classList.toggle('is-active',favoriteKeys.has(`${Number(select.dataset.variantProduct)}:${attr}`));}
    const pn=card.querySelector('[data-product-price]'); if(pn) pn.textContent=money.format(price); const meta=card.querySelector('[data-product-meta]'); if(meta) meta.textContent=`SKU: ${ref} · Stock: ${stock}`; const badge=card.querySelector('[data-stock-badge]'); if(badge) badge.innerHTML=stockBadge(stock); const promo=card.querySelector('[data-product-promo]'); if(promo) promo.innerHTML=promotionMarkup(price,regularPrice,discount,tiers); const qty=card.querySelector('[data-card-qty]'); if(qty){qty.max=String(Math.max(1,stock)); if(Number(qty.value)>stock&&stock>0) qty.value=String(stock)} card.toggleAttribute('data-out',stock<=0);
  });
  syncSearchClear();
  searchInput.addEventListener('input', () => {
    clearTimeout(searchTimer);
    syncSearchClear();
    const query = searchInput.value.trim();
    if (query.length === 0) {
      if (searchController) searchController.abort();
      renderRootCategories();
      return;
    }
    if (query.length < 2) return;
    searchTimer = window.setTimeout(() => runSearch(query), 220);
  });

  searchClear?.addEventListener('click', clearSearch);

  searchButton?.addEventListener('click', () => {
    const query = searchInput.value.trim();
    if (query.length >= 2) runSearch(query);
    else searchInput.focus();
  });

  browser.addEventListener('scroll', () => {
    if (mode === 'category' && categoryHasMore && !categoryLoading && browser.scrollTop + browser.clientHeight >= browser.scrollHeight - 500) {
      loadMoreCategoryProducts();
    }
  }, { passive: true });

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting) && mode === 'category' && categoryHasMore) {
      loadMoreCategoryProducts();
    }
  }, { rootMargin: '500px 0px' });
  observer.observe(sentinel);

  if (homeSlider && isHomeSliderDismissed()) homeSlider.hidden = true;

  setupPwa();
  let lastMobileState = isMobileViewport();
  let responsiveTimer = null;
  window.addEventListener('resize', () => {
    clearTimeout(responsiveTimer);
    responsiveTimer = window.setTimeout(() => {
      const mobileState = isMobileViewport();
      updatePwaInstallButton();
      if (mobileState !== lastMobileState) {
        lastMobileState = mobileState;
        if (mode === 'categories' && searchInput.value.trim() === '') renderRootCategories();
        else setHomeSliderVisible(mode === 'categories' && searchInput.value.trim() === '');
      }
    }, 140);
  }, { passive: true });

  // Las categorías iniciales viajan con el HTML. Así la portada queda operativa
  // sin esperar una petición AJAX adicional; el endpoint queda como fallback.
  categories = Array.isArray(initialCatalog.items) ? initialCatalog.items : [];
  rootCategoryId = Number(initialCatalog.rootId || root.dataset.rootCategoryId || 0);
  if (categories.length) {
    renderRootCategories();
    const categoryPayload = { ok: true, rootId: rootCategoryId, items: categories };
    const categoryCacheKey = requestCacheKey('categories', {});
    writeResponseCache(categoryCacheKey, categoryPayload, cacheTtls.categories);
  } else {
    request('categories')
      .then((categoryPayload) => {
        categories = Array.isArray(categoryPayload.items) ? categoryPayload.items : [];
        rootCategoryId = Number(categoryPayload.rootId || 0);
        renderRootCategories();
      })
      .catch((error) => {
        browser.innerHTML = '<div class="gq__loading">No se pudo cargar el catálogo. Vuelve a intentarlo.</div>';
        notify(error.message);
      });
  }

  // Un único bootstrap lateral sustituye las peticiones separadas de carrito y
  // direcciones. Transporte y pago se calculan después porque dependen del carrito.
  request('sessionState', {}, 'GET', { force: true })
    .then(async (payload) => {
      if (payload.token) {
        token = String(payload.token);
        root.dataset.token = token;
      }
      if (payload.customer?.logged) {
        renderCustomer(payload.customer);
        renderAddresses(payload.addresses || [], payload.selectedAddressId || payload.customer.addressId || 0);
      }
      renderCart(payload.cart || {});

      if (payload.customer?.logged && payload.carriers && Array.isArray(payload.carriers.items)) {
        renderCarriers(payload.carriers.items, payload.carriers.selectedKey || '');
      } else if (payload.customer?.logged) {
        await refreshCarriers();
      }

      if (Array.isArray(payload.payments)) {
        renderPaymentOptions(payload.payments);
      } else {
        await refreshPayments();
      }
    })
    .catch((error) => {
      console.warn('[Ganesh POS] No se pudo completar el estado lateral de Compra rápida:', error);
    });

  const deepLinkParams = new URLSearchParams(window.location.search);
  const deepProductId = Number(deepLinkParams.get('gq_product') || 0);
  const deepAttributeId = Number(deepLinkParams.get('gq_attribute') || 0);
  if (deepProductId > 0) {
    window.setTimeout(() => openQuickView(deepProductId, deepAttributeId), 650);
  }

})();
